var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 72,
  height: 72,
  viewBox: "0 0 72 72"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  id: "Path_646",
  "data-name": "Path 646",
  d: "M36,0A36,36,0,1,1,0,36,36,36,0,0,1,36,0Z",
  fill: "#f8f8f8"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "man_catches_bill",
  "data-name": "man catches bill",
  transform: "translate(5.883 8.845)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_370",
  "data-name": "Path 370",
  d: "M585.646,1934.06s-1.012,3.891-1.953,5.216a18.588,18.588,0,0,0,11.614,3.1s1.012-3,1.5-5.231c0,0-2.232,1.081-6.1-.489C586.361,1934.9,585.646,1934.06,585.646,1934.06Z",
  transform: "translate(-577.356 -1897.994)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_371",
  "data-name": "Path 371",
  d: "M590.3,1938.418a20.279,20.279,0,0,1-7.635-1.46,14.239,14.239,0,0,1-3.108-1.682.09.09,0,0,1-.033-.057.087.087,0,0,1,.015-.063c.922-1.3,1.93-5.148,1.94-5.187a.089.089,0,0,1,.024-.041.088.088,0,0,1,.089-.021.089.089,0,0,1,.039.027c.008.009.78.855,5.022,2.576a10.047,10.047,0,0,0,4.452.828,4.751,4.751,0,0,0,1.579-.337.089.089,0,0,1,.048-.008.086.086,0,0,1,.045.019.088.088,0,0,1,.028.04.089.089,0,0,1,0,.049c-.484,2.211-1.491,5.21-1.5,5.241a.086.086,0,0,1-.03.042.089.089,0,0,1-.048.018Q590.759,1938.419,590.3,1938.418Zm-10.568-3.232a14.653,14.653,0,0,0,3.006,1.61,20.215,20.215,0,0,0,8.423,1.428c.138-.416.986-2.99,1.441-5a5.447,5.447,0,0,1-1.471.288,10.22,10.22,0,0,1-4.543-.839,20.121,20.121,0,0,1-4.976-2.517A22.954,22.954,0,0,1,579.735,1935.187Z",
  transform: "translate(-573.278 -1893.924)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_372",
  "data-name": "Path 372",
  d: "M646.78,2012.68a30.745,30.745,0,0,1-1.317,3.379,16.686,16.686,0,0,0,9.5,2.393,21.969,21.969,0,0,0,.953-3.164,8.337,8.337,0,0,1-4.9-.72A37.521,37.521,0,0,1,646.78,2012.68Z",
  transform: "translate(-637.816 -1974.945)",
  fill: "#9cbd6b"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_373",
  "data-name": "Path 373",
  d: "M651.517,2015.816a17.6,17.6,0,0,1-6.165-1.123,13.488,13.488,0,0,1-2.631-1.295.06.06,0,0,1-.024-.035.058.058,0,0,1,.005-.041,30.56,30.56,0,0,0,1.313-3.37.056.056,0,0,1,.013-.023.059.059,0,0,1,.022-.014.067.067,0,0,1,.026,0,.059.059,0,0,1,.025.008,37.822,37.822,0,0,0,4.223,1.881,8.385,8.385,0,0,0,4.868.718.065.065,0,0,1,.03,0,.068.068,0,0,1,.026.014.062.062,0,0,1,.016.026.06.06,0,0,1,0,.03,22.343,22.343,0,0,1-.956,3.173.06.06,0,0,1-.021.026.059.059,0,0,1-.032.011Q651.882,2015.815,651.517,2015.816Zm-8.687-2.486a13.909,13.909,0,0,0,2.567,1.255,17.449,17.449,0,0,0,6.817,1.1,22.39,22.39,0,0,0,.917-3.029,8.863,8.863,0,0,1-4.851-.746,43.825,43.825,0,0,1-4.176-1.853,30.413,30.413,0,0,1-1.274,3.274Z",
  transform: "translate(-635.107 -1972.236)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_374",
  "data-name": "Path 374",
  d: "M1468.329,2494.337a39.113,39.113,0,0,0,.489,3.941l-.7.733h2.209l-.29-5.091Z",
  transform: "translate(-1443.02 -2445.976)",
  fill: "#f6aa65"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_375",
  "data-name": "Path 375",
  d: "M1466.269,2495.018h-2.209a.092.092,0,0,1-.048-.015.087.087,0,0,1-.033-.039.09.09,0,0,1,.017-.1l.667-.7c-.306-1.525-.479-3.884-.481-3.907a.087.087,0,0,1,.017-.058.086.086,0,0,1,.05-.034l1.709-.419a.085.085,0,0,1,.038,0,.086.086,0,0,1,.035.015.093.093,0,0,1,.025.029.089.089,0,0,1,.01.037l.29,5.092a.085.085,0,0,1-.005.035.094.094,0,0,1-.019.031.091.091,0,0,1-.029.02.089.089,0,0,1-.035.007Zm-2-.177h1.908l-.279-4.892-1.533.375a38.211,38.211,0,0,0,.481,3.854.09.09,0,0,1,0,.042.086.086,0,0,1-.021.036Z",
  transform: "translate(-1438.96 -2441.894)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_376",
  "data-name": "Path 376",
  d: "M1469.463,2633.877a1.027,1.027,0,0,1-.715.123c.022.127.046.251.07.37l-.7.733h2.209l-.122-2.142a.8.8,0,0,0-.314.172C1469.659,2633.328,1469.659,2633.68,1469.463,2633.877Z",
  transform: "translate(-1443.02 -2582.067)",
  fill: "#9cbd6b"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_377",
  "data-name": "Path 377",
  d: "M1467.621,2632.442h-2.209a.059.059,0,0,1-.032-.01.057.057,0,0,1-.022-.026.054.054,0,0,1,0-.034.056.056,0,0,1,.015-.03l.676-.71c-.021-.106-.043-.222-.064-.341a.055.055,0,0,1,0-.027.059.059,0,0,1,.034-.038.06.06,0,0,1,.026,0,.99.99,0,0,0,.673-.109.945.945,0,0,0,.173-.321.97.97,0,0,1,.259-.426.852.852,0,0,1,.334-.183.056.056,0,0,1,.026,0,.067.067,0,0,1,.024.01.058.058,0,0,1,.017.02.059.059,0,0,1,.008.026l.122,2.142a.055.055,0,0,1,0,.023.059.059,0,0,1-.012.021.068.068,0,0,1-.019.014A.064.064,0,0,1,1467.621,2632.442Zm-2.072-.118h2.009l-.114-2a.725.725,0,0,0-.219.134.883.883,0,0,0-.226.38,1.018,1.018,0,0,1-.2.364l-.006.005a.986.986,0,0,1-.68.139c.019.1.039.2.057.294a.061.061,0,0,1,0,.028.051.051,0,0,1-.014.024Z",
  transform: "translate(-1440.312 -2579.348)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_378",
  "data-name": "Path 378",
  d: "M1479.8,2495.865l-.11-1.945-1.71.417s.051.708.149,1.6a13.509,13.509,0,0,1,1.672-.074Z",
  transform: "translate(-1452.671 -2445.976)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_379",
  "data-name": "Path 379",
  d: "M1545.561,2676.613a.151.151,0,1,0-.151-.151A.152.152,0,0,0,1545.561,2676.613Z",
  transform: "translate(-1518.671 -2624.497)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_380",
  "data-name": "Path 380",
  d: "M1545.561,2702.983a.151.151,0,1,0-.151-.151A.151.151,0,0,0,1545.561,2702.983Z",
  transform: "translate(-1518.671 -2650.308)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_381",
  "data-name": "Path 381",
  d: "M2257.75,2494.338l1.055,3.941-.7.733h2.209l-.857-5.092Z",
  transform: "translate(-2215.898 -2445.976)",
  fill: "#f6aa65"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_382",
  "data-name": "Path 382",
  d: "M2256.258,2495.016h-2.209A.091.091,0,0,1,2254,2495a.087.087,0,0,1-.032-.039.086.086,0,0,1-.006-.051.1.1,0,0,1,.022-.045l.664-.7-1.042-3.893a.11.11,0,0,1,0-.035.094.094,0,0,1,.011-.033.091.091,0,0,1,.024-.026.079.079,0,0,1,.031-.015l1.709-.419a.085.085,0,0,1,.036,0,.086.086,0,0,1,.059.039.08.08,0,0,1,.013.033l.857,5.092a.1.1,0,0,1,0,.038.089.089,0,0,1-.048.057A.094.094,0,0,1,2256.258,2495.016Zm-2-.177h1.9l-.824-4.9-1.53.374,1.031,3.854a.1.1,0,0,1,0,.044.091.091,0,0,1-.022.039Z",
  transform: "translate(-2211.84 -2441.892)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_383",
  "data-name": "Path 383",
  d: "M2275.923,2639.867a1.1,1.1,0,0,1-.737.146s.068.228.092.347l-.7.733h2.209l-.338-2.013C2276.183,2639.14,2276.119,2639.671,2275.923,2639.867Z",
  transform: "translate(-2232.372 -2588.057)",
  fill: "#9cbd6b"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_384",
  "data-name": "Path 384",
  d: "M2274.081,2638.4h-2.209a.06.06,0,0,1-.054-.036.059.059,0,0,1,0-.034.054.054,0,0,1,.016-.03l.676-.71c-.028-.118-.085-.31-.085-.314a.055.055,0,0,1,0-.028.059.059,0,0,1,.012-.025.059.059,0,0,1,.022-.017.058.058,0,0,1,.028,0,1.061,1.061,0,0,0,.7-.131,1.175,1.175,0,0,0,.18-.328c.091-.212.184-.431.373-.471a.064.064,0,0,1,.024,0,.05.05,0,0,1,.022.009.055.055,0,0,1,.017.017.057.057,0,0,1,.009.023l.339,2.011a.074.074,0,0,1,0,.026.059.059,0,0,1-.032.038.054.054,0,0,1-.025.006Zm-2.072-.118h2l-.314-1.871a.894.894,0,0,0-.232.379,1.2,1.2,0,0,1-.208.368l-.006.006a1.076,1.076,0,0,1-.693.162c.022.078.055.2.07.271a.062.062,0,0,1,0,.028.06.06,0,0,1-.014.024Z",
  transform: "translate(-2229.663 -2585.31)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_385",
  "data-name": "Path 385",
  d: "M2259.71,2495.9l-.32-1.983-1.711.417.439,1.642a12.378,12.378,0,0,1,1.591-.076Z",
  transform: "translate(-2215.83 -2445.976)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_386",
  "data-name": "Path 386",
  d: "M2346.4,2679.663a.152.152,0,1,0-.152-.151A.151.151,0,0,0,2346.4,2679.663Z",
  transform: "translate(-2302.521 -2627.482)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_387",
  "data-name": "Path 387",
  d: "M2352.021,2702.983a.151.151,0,1,0-.151-.151A.151.151,0,0,0,2352.021,2702.983Z",
  transform: "translate(-2308.022 -2650.308)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_388",
  "data-name": "Path 388",
  d: "M1490.572,2546.69a.017.017,0,0,1-.009,0,.016.016,0,0,1,0-.01.016.016,0,0,1,.013-.015l.6-.054h.006l0,0,0,0a.012.012,0,0,1,0,.005.013.013,0,0,1,0,.006l0,.005,0,0-.006,0-.6.054Z",
  transform: "translate(-1464.984 -2497.544)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_389",
  "data-name": "Path 389",
  d: "M1507.09,2557.919h-.186a.014.014,0,0,1-.01,0,.015.015,0,0,1,0-.01.013.013,0,0,1,0-.01.015.015,0,0,1,.01,0h.186l.006,0,0,0a.011.011,0,0,1,0,0,.017.017,0,0,1,0,.006.016.016,0,0,1,0,.01.017.017,0,0,1-.01,0Z",
  transform: "translate(-1480.968 -2508.589)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_390",
  "data-name": "Path 390",
  d: "M1495.951,2576.681a.016.016,0,0,1-.01,0,.016.016,0,0,1,0-.01.017.017,0,0,1,0-.006l0,0,0,0h.006l.721-.046h.005l.005,0,0,0a.013.013,0,0,1,0,.006.015.015,0,0,1,0,.011.017.017,0,0,1-.01,0l-.721.046Z",
  transform: "translate(-1470.247 -2526.908)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_391",
  "data-name": "Path 391",
  d: "M1544.32,2564.48h-.118a.013.013,0,0,1-.009-.005.015.015,0,0,1,0-.01.015.015,0,0,1,0-.01.013.013,0,0,1,.009-.005h.118a.015.015,0,0,1,.009.005.015.015,0,0,1,0,.01.015.015,0,0,1-.012.015Z",
  transform: "translate(-1517.477 -2515.01)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_392",
  "data-name": "Path 392",
  d: "M2280.611,2547.735a.016.016,0,0,1-.01,0,.014.014,0,0,1,0-.02.013.013,0,0,1,.009-.005l.535-.046a.014.014,0,0,1,.01,0,.014.014,0,0,1,.005.01.015.015,0,0,1,0,.006l0,0a.007.007,0,0,1,0,0l-.006,0-.535.046Z",
  transform: "translate(-2238.26 -2498.575)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_393",
  "data-name": "Path 393",
  d: "M2291.888,2560.089h-.187a.013.013,0,0,1-.009,0,.014.014,0,0,1,0-.01.015.015,0,0,1,0-.01.015.015,0,0,1,.009,0h.193l.006,0,0,.005a.025.025,0,0,1,0,.006.033.033,0,0,1,0,.007l0,0-.006,0Z",
  transform: "translate(-2249.118 -2510.713)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_394",
  "data-name": "Path 394",
  d: "M2324.707,2561.189h-.238l-.005,0,0,0a.011.011,0,0,1,0-.006.017.017,0,0,1,0-.01.016.016,0,0,1,.011,0h.238l0,0a.01.01,0,0,1,0,.005.01.01,0,0,1,0,0,.014.014,0,0,1,0,.006l0,0,0,0Z",
  transform: "translate(-2281.193 -2511.79)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_395",
  "data-name": "Path 395",
  d: "M2304.75,2575.446a.013.013,0,0,1-.009,0,.016.016,0,0,1-.005-.008.028.028,0,0,1,0-.006.01.01,0,0,1,0,0l0,0,.005,0,.256-.046a.015.015,0,0,1,.011,0,.014.014,0,0,1,.006.01.011.011,0,0,1,0,.006.013.013,0,0,1,0,.005l0,0-.005,0-.256.046Z",
  transform: "translate(-2261.887 -2525.698)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_396",
  "data-name": "Path 396",
  d: "M1452.293,2734.018h-26.814a.038.038,0,0,1-.028-.011.039.039,0,0,1-.012-.028.038.038,0,0,1,.012-.027.039.039,0,0,1,.028-.011h26.813a.039.039,0,0,1,.028.067.038.038,0,0,1-.028.011Z",
  transform: "translate(-1401.246 -2680.905)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_397",
  "data-name": "Path 397",
  d: "M2099.389,871.7s1.285-.435,2.163-.632a23.949,23.949,0,0,0,1.137,3.737l-2.14,1.4Z",
  transform: "translate(-2060.898 -857.55)",
  fill: "#dc5c3f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_398",
  "data-name": "Path 398",
  d: "M2096.488,872.284a.094.094,0,0,1-.032-.006.091.091,0,0,1-.034-.024.086.086,0,0,1-.019-.036l-1.161-4.507a.088.088,0,0,1,.057-.106c.013,0,1.3-.439,2.171-.635a.087.087,0,0,1,.067.012.1.1,0,0,1,.025.024.1.1,0,0,1,.014.031,23.776,23.776,0,0,0,1.131,3.715.091.091,0,0,1,.007.063.094.094,0,0,1-.037.052l-2.139,1.4a.089.089,0,0,1-.05.014Zm-1.054-4.538,1.111,4.308,1.97-1.292a23.554,23.554,0,0,1-1.091-3.6C2096.691,867.335,2095.713,867.654,2095.434,867.747Z",
  transform: "translate(-2056.835 -853.54)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_399",
  "data-name": "Path 399",
  d: "M2169.7,848.844s4.3-1.329,4.808-.259c.458.972-1.858,1.9-4.381,2.97Z",
  transform: "translate(-2129.716 -835.139)",
  fill: "#f6aa65"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_400",
  "data-name": "Path 400",
  d: "M2166.061,847.589a.087.087,0,0,1-.087-.074l-.427-2.711a.085.085,0,0,1,.012-.06.088.088,0,0,1,.049-.038,20.692,20.692,0,0,1,2.226-.534c1.556-.271,2.459-.163,2.687.321a.661.661,0,0,1,.019.536c-.307.8-2.079,1.552-4.128,2.419l-.317.134a.083.083,0,0,1-.034.007Zm-.326-2.737.4,2.523.213-.09c1.929-.816,3.751-1.587,4.031-2.32a.484.484,0,0,0-.014-.4C2169.983,843.764,2166.962,844.481,2165.735,844.852Z",
  transform: "translate(-2125.651 -831.085)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_401",
  "data-name": "Path 401",
  d: "M2301.333,858.61a.058.058,0,0,1-.043-.012.06.06,0,0,1-.01-.083.061.061,0,0,1,.04-.022,2.975,2.975,0,0,0,1.177-.456c.007-.023,0-.03,0-.035-.1-.116-.805-.033-1.27.063a.06.06,0,0,1-.044-.009.057.057,0,0,1-.025-.037.056.056,0,0,1,.009-.044.057.057,0,0,1,.037-.025c.2-.039,1.193-.236,1.381-.026a.147.147,0,0,1,.035.071.152.152,0,0,1-.006.079c-.073.229-.985.467-1.263.534l-.012,0Z",
  transform: "translate(-2258.379 -844.594)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_402",
  "data-name": "Path 402",
  d: "M2171.453,859.136c-.951.2-1.753.443-1.753.443l.427,2.711c.616-.261,1.22-.514,1.774-.761A7.6,7.6,0,0,1,2171.453,859.136Z",
  transform: "translate(-2129.716 -845.874)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_403",
  "data-name": "Path 403",
  d: "M2043.568,275.122a.3.3,0,0,1-.394-.144S2038,255.05,2029.26,241.8c7.5,9.462,14.491,32.945,14.491,32.945A.3.3,0,0,1,2043.568,275.122Z",
  transform: "translate(-1992.256 -241.634)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_404",
  "data-name": "Path 404",
  d: "M2040.763,272.557a.371.371,0,0,1-.146-.03.323.323,0,0,1-.105-.071.319.319,0,0,1-.069-.106.016.016,0,0,1,0-.007c-.013-.05-1.32-5.056-3.678-11.616-2.176-6.053-5.716-14.7-10.229-21.545a.057.057,0,0,1-.008-.042.058.058,0,0,1,.064-.047.059.059,0,0,1,.038.02,50.553,50.553,0,0,1,5.437,9.15c1.514,3.126,3.072,6.788,4.63,10.886,2.632,6.915,4.385,12.769,4.433,12.926a.32.32,0,0,1,0,.246.385.385,0,0,1-.213.206h0a.4.4,0,0,1-.15.03Zm-.21-.246a.2.2,0,0,0,.11.109.268.268,0,0,0,.206,0h0a.27.27,0,0,0,.148-.143.2.2,0,0,0,.017-.078.207.207,0,0,0-.014-.079.024.024,0,0,1,0-.006c-.018-.058-1.778-5.949-4.431-12.92-2.237-5.872-5.54-13.627-9.044-18.648a85.891,85.891,0,0,1,4.955,9.357c1.518,3.3,2.99,6.933,4.375,10.79,2.33,6.487,3.635,11.456,3.677,11.619Z",
  transform: "translate(-1989.579 -238.985)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_405",
  "data-name": "Path 405",
  d: "M2204.259,868.065c.584-.242,1.708-.259,1.825.08.081.236-.411.343-.411.343s.544.014.641.255-.381.385-.381.385.513.016.539.314c.022.255-.554.363-1.016.642-.964.583-2.22,3.364-2.22,3.364l-1.906-2.615C2202.516,869.157,2203.313,868.42,2204.259,868.065Z",
  transform: "translate(-2160.676 -854.439)",
  fill: "#f6aa65"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_406",
  "data-name": "Path 406",
  d: "M2199.174,869.454a.088.088,0,0,1-.04-.01.091.091,0,0,1-.031-.027L2197.2,866.8a.087.087,0,0,1,0-.1c1.183-1.671,1.988-2.429,2.969-2.8a2.709,2.709,0,0,1,1.719-.078.376.376,0,0,1,.221.212.236.236,0,0,1,.013.1.233.233,0,0,1-.031.1.4.4,0,0,1-.137.134.534.534,0,0,1,.383.263.249.249,0,0,1-.007.208.463.463,0,0,1-.166.172.42.42,0,0,1,.336.342c.02.228-.254.348-.571.486a4.181,4.181,0,0,0-.487.239c-.93.562-2.173,3.3-2.185,3.324a.089.089,0,0,1-.029.036.091.091,0,0,1-.042.016Zm-1.8-2.7,1.781,2.442c.27-.576,1.328-2.744,2.192-3.266a4.347,4.347,0,0,1,.507-.25c.236-.1.474-.207.466-.309-.019-.212-.449-.232-.454-.232a.087.087,0,0,1-.056-.023.089.089,0,0,1-.028-.054.088.088,0,0,1,.014-.059.086.086,0,0,1,.048-.037.613.613,0,0,0,.322-.2.071.071,0,0,0,0-.066c-.057-.141-.4-.2-.561-.2a.088.088,0,0,1-.058-.023.092.092,0,0,1-.028-.056.087.087,0,0,1,.017-.061.086.086,0,0,1,.052-.034.627.627,0,0,0,.342-.175.056.056,0,0,0,.009-.026.06.06,0,0,0,0-.027.234.234,0,0,0-.127-.108,2.55,2.55,0,0,0-1.58.078h0C2199.293,864.418,2198.517,865.147,2197.376,866.75Z",
  transform: "translate(-2156.613 -850.358)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_407",
  "data-name": "Path 407",
  d: "M2413.519,938.769a.064.064,0,0,1-.034-.011.06.06,0,0,1-.021-.028l-.05-.139a.064.064,0,0,1,0-.023.064.064,0,0,1,0-.023.063.063,0,0,1,.014-.02.062.062,0,0,1,.021-.012.061.061,0,0,1,.024,0,.058.058,0,0,1,.023.007.056.056,0,0,1,.018.015.059.059,0,0,1,.011.021l.05.139a.056.056,0,0,1,0,.028.053.053,0,0,1-.01.026.057.057,0,0,1-.021.018.056.056,0,0,1-.027.007Z",
  transform: "translate(-2368.256 -923.562)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_408",
  "data-name": "Path 408",
  d: "M2403.014,908.068a.059.059,0,0,1-.034-.011.066.066,0,0,1-.022-.028l-.05-.139a.072.072,0,0,1,0-.023.064.064,0,0,1,.006-.022.058.058,0,0,1,.014-.018.054.054,0,0,1,.02-.012.057.057,0,0,1,.023,0,.061.061,0,0,1,.022.006.054.054,0,0,1,.018.014.068.068,0,0,1,.012.02l.049.139a.058.058,0,0,1,0,.045.056.056,0,0,1-.033.03.059.059,0,0,1-.02,0Z",
  transform: "translate(-2357.975 -893.516)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_409",
  "data-name": "Path 409",
  d: "M2391.384,877.941a.06.06,0,0,1-.056-.039l-.05-.139a.071.071,0,0,1,0-.023.059.059,0,0,1,.006-.022.06.06,0,0,1,.014-.018.055.055,0,0,1,.019-.012.065.065,0,0,1,.023,0,.056.056,0,0,1,.022.006.055.055,0,0,1,.018.014.073.073,0,0,1,.012.02l.049.139a.055.055,0,0,1,0,.028.058.058,0,0,1-.031.044.057.057,0,0,1-.027.007Z",
  transform: "translate(-2346.592 -864.029)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_410",
  "data-name": "Path 410",
  d: "M2202.447,937.052a16.2,16.2,0,0,0-1.157,1.477l1.906,2.615a18.93,18.93,0,0,1,1.187-2.188A10.58,10.58,0,0,0,2202.447,937.052Z",
  transform: "translate(-2160.636 -922.137)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_411",
  "data-name": "Path 411",
  d: "M1600.47,578.788a4.771,4.771,0,0,1,.507,1.221s1.6-.093,1.286-.633c-.737-1.251-1.183-1.87-1.183-1.87Z",
  transform: "translate(-1572.563 -570.22)",
  fill: "#f6aa65"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_412",
  "data-name": "Path 412",
  d: "M1598.25,577.348a.059.059,0,0,1-.057-.045,4.751,4.751,0,0,0-.5-1.2.059.059,0,0,1-.008-.027.053.053,0,0,1,.005-.028l.61-1.282a.057.057,0,0,1,.02-.023.058.058,0,0,1,.028-.01.059.059,0,0,1,.03.005.058.058,0,0,1,.023.019c0,.006.455.635,1.186,1.875a.28.28,0,0,1,.019.287c-.19.357-1.233.427-1.351.434Zm-.441-1.283a4.837,4.837,0,0,1,.486,1.163c.334-.025,1.077-.129,1.205-.369a.162.162,0,0,0-.016-.172c-.578-.981-.98-1.576-1.122-1.783Z",
  transform: "translate(-1569.836 -567.5)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_413",
  "data-name": "Path 413",
  d: "M1414.313,1331.56s-4.133,5.567-1.622,22.146a18.413,18.413,0,0,1,4.29,0,30.844,30.844,0,0,1,1.151-9.944c1.36-4.551,3.7-7.36,4.685-7.219.325.047.664.53.86.907,2.023,3.885,5.389,16.257,5.389,16.257a15.172,15.172,0,0,1,4.238,0s-.941-23.492-4.551-25.716Z",
  transform: "translate(-1387.975 -1304.781)",
  fill: "#fdbc12"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_414",
  "data-name": "Path 414",
  d: "M1408.623,1349.686a.088.088,0,0,1-.057-.021.09.09,0,0,1-.03-.054,65.4,65.4,0,0,1-.807-10.469,36.147,36.147,0,0,1,.677-6.853,13.346,13.346,0,0,1,1.768-4.89.087.087,0,0,1,.05-.033l14.439-3.57a.09.09,0,0,1,.035,0,.083.083,0,0,1,.033.012c1.521.937,2.757,5.566,3.671,13.757.679,6.084.92,11.971.922,12.03a.086.086,0,0,1-.007.039.088.088,0,0,1-.024.032.093.093,0,0,1-.035.018.094.094,0,0,1-.04,0,15.288,15.288,0,0,0-4.207,0,.088.088,0,0,1-.1-.064c-.034-.123-3.386-12.409-5.381-16.239-.194-.372-.518-.82-.795-.86-.468-.067-1.3.645-2.119,1.813a19.148,19.148,0,0,0-2.472,5.344,31.09,31.09,0,0,0-1.145,9.914.086.086,0,0,1-.006.04.087.087,0,0,1-.023.033.086.086,0,0,1-.035.019.085.085,0,0,1-.04,0,18.6,18.6,0,0,0-4.262,0Zm1.675-22.156a13.937,13.937,0,0,0-1.723,4.815c-.65,3.141-1.154,8.665.123,17.156a18.272,18.272,0,0,1,4.12-.01,31.345,31.345,0,0,1,1.161-9.862,19.3,19.3,0,0,1,2.495-5.394c.883-1.26,1.738-1.966,2.287-1.887.432.061.818.745.926.953,1.923,3.688,5.09,15.161,5.375,16.2a15.409,15.409,0,0,1,4.081-.011c-.037-.845-.29-6.292-.917-11.906-.889-7.964-2.119-12.664-3.557-13.606Z",
  transform: "translate(-1383.907 -1300.674)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_415",
  "data-name": "Path 415",
  d: "M1665.222,1397.764a35.782,35.782,0,0,1-5.336,1.1c-.821,1.941-1.253,4.061-2.306,5.917,1.673.922,2.165.782,2.685-.85.16-.5.513-1.775.966-3.165,7.141-.84,10.535-2.919,10.535-2.919l-.637-1.895C1669.159,1396.509,1667.206,1397.152,1665.222,1397.764Z",
  transform: "translate(-1628.461 -1371.3)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_416",
  "data-name": "Path 416",
  d: "M1444.38,2494.384q.057.406.12.821a18.408,18.408,0,0,1,4.29,0s-.024-.319-.035-.878A19.435,19.435,0,0,0,1444.38,2494.384Z",
  transform: "translate(-1419.784 -2446.28)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_417",
  "data-name": "Path 417",
  d: "M1441.793,2492.582a.06.06,0,0,1-.039-.014.058.058,0,0,1-.02-.036c-.039-.266-.08-.542-.12-.821a.061.061,0,0,1,.011-.043.056.056,0,0,1,.038-.023,19.483,19.483,0,0,1,4.388-.059.06.06,0,0,1,.038.018.057.057,0,0,1,.016.039c.01.549.034.873.034.876a.053.053,0,0,1,0,.027.063.063,0,0,1-.016.022.06.06,0,0,1-.023.012.055.055,0,0,1-.027,0,18.511,18.511,0,0,0-4.272,0Zm-.054-.829c.034.24.069.476.1.706a18.642,18.642,0,0,1,4.176-.008c-.007-.121-.021-.381-.028-.752a19.361,19.361,0,0,0-4.251.054Z",
  transform: "translate(-1417.077 -2443.599)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_418",
  "data-name": "Path 418",
  d: "M2211.87,2492.645c.136.488.212.767.212.767a15.183,15.183,0,0,1,4.238,0s-.013-.312-.04-.866A12.644,12.644,0,0,0,2211.87,2492.645Z",
  transform: "translate(-2170.991 -2444.488)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_419",
  "data-name": "Path 419",
  d: "M2209.367,2490.759a.057.057,0,0,1-.036-.012.06.06,0,0,1-.021-.031s-.076-.28-.212-.767a.059.059,0,0,1,0-.024.063.063,0,0,1,.008-.022.064.064,0,0,1,.017-.018.058.058,0,0,1,.023-.009,12.662,12.662,0,0,1,4.43-.1.062.062,0,0,1,.035.019.057.057,0,0,1,.015.036c.027.55.04.864.04.867a.064.064,0,0,1-.005.026.052.052,0,0,1-.016.021.059.059,0,0,1-.023.012.065.065,0,0,1-.027,0,15.233,15.233,0,0,0-4.217,0Zm-.138-.781c.093.334.157.563.181.657a15.385,15.385,0,0,1,4.133-.008c-.005-.118-.017-.375-.035-.742a12.555,12.555,0,0,0-4.28.094Z",
  transform: "translate(-2168.277 -2441.776)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_420",
  "data-name": "Path 420",
  d: "M829.372,2145.653c.1-.372-.373-.825-1.06-1.014s-1.327-.039-1.429.333.373.825,1.061,1.013S829.27,2146.024,829.372,2145.653Z",
  transform: "translate(-815.374 -2104.026)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_421",
  "data-name": "Path 421",
  d: "M825.792,2143.17a2.3,2.3,0,0,1-.6-.085,2.013,2.013,0,0,1-.851-.452.658.658,0,0,1-.251-.634c.112-.408.772-.573,1.5-.373s1.214.677,1.1,1.086C826.612,2143,826.255,2143.17,825.792,2143.17Zm-.794-1.509c-.409,0-.732.135-.8.369a.549.549,0,0,0,.218.517,1.9,1.9,0,0,0,.8.424c.644.176,1.265.043,1.356-.291s-.375-.765-1.02-.941a2.128,2.128,0,0,0-.56-.078Z",
  transform: "translate(-812.637 -2101.073)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_422",
  "data-name": "Path 422",
  d: "M672.394,1988.465a.556.556,0,1,0-.623.253A.485.485,0,0,0,672.394,1988.465Z",
  transform: "translate(-663.154 -1950.698)",
  fill: "#9cbd6b"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_423",
  "data-name": "Path 423",
  d: "M680.071,1991.194a.735.735,0,0,1-.2-.026.689.689,0,0,1-.367-.236.4.4,0,0,1-.09-.175.4.4,0,0,1,.267-.474.721.721,0,0,1,.8.22.425.425,0,0,1,.086.372A.492.492,0,0,1,680.071,1991.194Zm-.147-.838a.51.51,0,0,0-.194.036.287.287,0,0,0-.128.469.569.569,0,0,0,.3.2.432.432,0,0,0,.555-.212.309.309,0,0,0-.065-.27.572.572,0,0,0-.3-.2.639.639,0,0,0-.167-.022Z",
  transform: "translate(-671.041 -1952.982)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_424",
  "data-name": "Path 424",
  d: "M1113.353,2116.25c.3-.012.53-.206.521-.432a.488.488,0,0,0-.555-.387c-.3.013-.53.206-.521.432A.488.488,0,0,0,1113.353,2116.25Z",
  transform: "translate(-1095.236 -2075.517)",
  fill: "#9cbd6b"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_425",
  "data-name": "Path 425",
  d: "M1110.641,2113.543a.676.676,0,0,1-.389-.115.419.419,0,0,1-.2-.329h0a.423.423,0,0,1,.167-.344.683.683,0,0,1,.41-.149.482.482,0,1,1,.04.936Zm.026-.82h-.027a.574.574,0,0,0-.34.122.306.306,0,0,0-.124.248h0a.3.3,0,0,0,.044.135.31.31,0,0,0,.1.1.572.572,0,0,0,.349.093c.264-.011.471-.177.464-.37s-.214-.329-.468-.329Z",
  transform: "translate(-1092.553 -2072.752)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_426",
  "data-name": "Path 426",
  d: "M1068.192,2263.259c.3-.012.53-.206.521-.432a.487.487,0,0,0-.555-.386c-.3.012-.53.206-.521.431A.487.487,0,0,0,1068.192,2263.259Z",
  transform: "translate(-1051.034 -2219.407)",
  fill: "#9cbd6b"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_427",
  "data-name": "Path 427",
  d: "M1065.551,2260.553a.679.679,0,0,1-.389-.115.419.419,0,0,1-.2-.329h0a.422.422,0,0,1,.166-.344.69.69,0,0,1,.41-.149.482.482,0,1,1,.039.936Zm.026-.82h-.028a.575.575,0,0,0-.34.122.277.277,0,0,0-.08.383.313.313,0,0,0,.1.1.574.574,0,0,0,.349.094c.264-.011.471-.177.464-.371s-.217-.329-.467-.329Z",
  transform: "translate(-1048.42 -2216.643)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_428",
  "data-name": "Path 428",
  d: "M621.521,2153.518a.559.559,0,1,0-.627.253A.488.488,0,0,0,621.521,2153.518Z",
  transform: "translate(-613.355 -2112.246)",
  fill: "#9cbd6b"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_429",
  "data-name": "Path 429",
  d: "M618.385,2150.951a.721.721,0,0,1-.2-.027.686.686,0,0,1-.366-.237.422.422,0,0,1-.086-.372.615.615,0,0,1,1.152.315A.493.493,0,0,1,618.385,2150.951Zm-.147-.84a.375.375,0,0,0-.388.236.308.308,0,0,0,.065.27.574.574,0,0,0,.3.2.432.432,0,0,0,.555-.212c.051-.187-.115-.4-.37-.465a.645.645,0,0,0-.167-.025Z",
  transform: "translate(-610.666 -2109.347)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_430",
  "data-name": "Path 430",
  d: "M409.055,2015.1a.062.062,0,0,1-.026-.005.065.065,0,0,1-.021-.017,5.3,5.3,0,0,1-.994-3.4,7.976,7.976,0,0,1,.251-1.837.062.062,0,0,1,.01-.021.06.06,0,0,1,.018-.015.056.056,0,0,1,.022-.008.054.054,0,0,1,.023,0,.062.062,0,0,1,.021.011.064.064,0,0,1,.015.018.059.059,0,0,1,.007.023.06.06,0,0,1,0,.023c-.009.031-.879,3.124.722,5.134a.06.06,0,0,1,.012.03.058.058,0,0,1-.006.032.061.061,0,0,1-.022.025A.058.058,0,0,1,409.055,2015.1Z",
  transform: "translate(-405.404 -1972.123)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_431",
  "data-name": "Path 431",
  d: "M331.861,2115.972a.053.053,0,0,1-.028-.007.057.057,0,0,1-.021-.019,5.716,5.716,0,0,1-.777-2.859.058.058,0,0,1,.1-.039.058.058,0,0,1,.016.042,5.587,5.587,0,0,0,.758,2.791.061.061,0,0,1,.008.045.058.058,0,0,1-.025.037.06.06,0,0,1-.031.01Z",
  transform: "translate(-330.059 -2073.167)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_432",
  "data-name": "Path 432",
  d: "M874.906,1983.251h-.01a1.294,1.294,0,0,1-.927-.907,2.138,2.138,0,0,1,.614-2.191.06.06,0,0,1,.039-.014.059.059,0,0,1,.038.016.057.057,0,0,1,.019.037.06.06,0,0,1-.01.04,2.021,2.021,0,0,0-.588,2.072,1.178,1.178,0,0,0,.835.829.058.058,0,0,1,.04.021.059.059,0,0,1,.014.043.058.058,0,0,1-.021.04.055.055,0,0,1-.043.014Z",
  transform: "translate(-861.384 -1943.096)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_433",
  "data-name": "Path 433",
  d: "M871.689,1971.493a.059.059,0,0,1-.058-.05,3.822,3.822,0,0,1-.014-.762,3.616,3.616,0,0,1-.752.483.053.053,0,0,1-.023,0,.051.051,0,0,1-.023,0,.06.06,0,0,1-.038-.054.061.061,0,0,1,0-.023.058.058,0,0,1,.013-.02.056.056,0,0,1,.019-.013,3.578,3.578,0,0,0,.833-.56.062.062,0,0,1,.032-.015.059.059,0,0,1,.066.065,4.076,4.076,0,0,0,0,.88.059.059,0,0,1-.011.044.059.059,0,0,1-.017.016.053.053,0,0,1-.022.008Z",
  transform: "translate(-858.354 -1933.639)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_434",
  "data-name": "Path 434",
  d: "M1015.016,2011.531a.059.059,0,0,1-.032-.01.055.055,0,0,1-.016-.016.058.058,0,0,1-.009-.021.052.052,0,0,1,0-.023.062.062,0,0,1,.008-.021,1.856,1.856,0,0,0,.039-1.546.054.054,0,0,1-.005-.023.055.055,0,0,1,0-.023.056.056,0,0,1,.013-.02.059.059,0,0,1,.042-.018.06.06,0,0,1,.042.018.057.057,0,0,1,.013.02,1.947,1.947,0,0,1-.051,1.657.057.057,0,0,1-.021.019A.056.056,0,0,1,1015.016,2011.531Z",
  transform: "translate(-999.472 -1972.137)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_435",
  "data-name": "Path 435",
  d: "M1010.795,1987.467a.178.178,0,0,1-.074-.015.307.307,0,1,1,.326-.18A.3.3,0,0,1,1010.795,1987.467Zm.091-.455a.189.189,0,0,0-.145.125c-.039.087-.026.184.027.207s.133-.033.171-.12.025-.183-.027-.207a.064.064,0,0,0-.025-.005Z",
  transform: "translate(-995.206 -1949.707)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_436",
  "data-name": "Path 436",
  d: "M296.233,2679.45a2.714,2.714,0,0,1-2.444-1.281,2.639,2.639,0,0,1-2.178,1.209H291.6a2.634,2.634,0,0,1-2.208-1.292,5.706,5.706,0,0,1-4.339.989.059.059,0,1,1,.022-.116,5.579,5.579,0,0,0,4.3-1.007.072.072,0,0,1,.024-.01.056.056,0,0,1,.025,0,.058.058,0,0,1,.023.011.055.055,0,0,1,.016.019,2.512,2.512,0,0,0,2.139,1.29h.015a2.513,2.513,0,0,0,2.141-1.261.058.058,0,0,1,.025-.024.058.058,0,0,1,.065.007.061.061,0,0,1,.018.029c.253.912,1.709,1.452,2.746,1.292a4.2,4.2,0,0,0,2.276-1.387.063.063,0,0,1,.023-.016.062.062,0,0,1,.028,0,.054.054,0,0,1,.026.01.056.056,0,0,1,.019.02,2.672,2.672,0,0,0,4.518.181.051.051,0,0,1,.021-.019.047.047,0,0,1,.028-.006.058.058,0,0,1,.028.007.056.056,0,0,1,.021.02,2.576,2.576,0,0,0,4.159.255.057.057,0,0,1,.039-.019.056.056,0,0,1,.042.013.06.06,0,0,1,.021.039.057.057,0,0,1-.011.042,2.693,2.693,0,0,1-4.3-.2,2.789,2.789,0,0,1-4.626-.188,4.289,4.289,0,0,1-2.293,1.366A2.626,2.626,0,0,1,296.233,2679.45Z",
  transform: "translate(-285 -2626.051)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_437",
  "data-name": "Path 437",
  d: "M701.544,2730.008h-.012a.91.91,0,0,1-.559-.374.054.054,0,0,1-.009-.021.06.06,0,0,1,0-.023.057.057,0,0,1,.009-.021.058.058,0,0,1,.037-.026.061.061,0,0,1,.023,0,.066.066,0,0,1,.021.009.054.054,0,0,1,.016.016.793.793,0,0,0,.486.326.061.061,0,0,1,.04.021.06.06,0,0,1,.013.043.059.059,0,0,1-.022.04.058.058,0,0,1-.043.013Z",
  transform: "translate(-692.138 -2676.599)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_438",
  "data-name": "Path 438",
  d: "M976.633,2741.752a2.513,2.513,0,0,1-1.309-.368.06.06,0,0,1-.019-.082.06.06,0,0,1,.081-.02,2.387,2.387,0,0,0,1.569.329.066.066,0,0,1,.023,0,.084.084,0,0,1,.021.01.055.055,0,0,1,.015.017.06.06,0,0,1,.008.022.068.068,0,0,1,0,.023.057.057,0,0,1-.01.021.069.069,0,0,1-.017.016.056.056,0,0,1-.022.007,2.4,2.4,0,0,1-.337.022Z",
  transform: "translate(-960.652 -2688.083)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_439",
  "data-name": "Path 439",
  d: "M1259.979,2741.43a.058.058,0,0,1-.042-.017.059.059,0,0,1,0-.083.059.059,0,0,1,.042-.017,2.973,2.973,0,0,0,1.468-.418.056.056,0,0,1,.045-.007.059.059,0,0,1,.043.071.06.06,0,0,1-.027.036,3.091,3.091,0,0,1-1.529.435Z",
  transform: "translate(-1239.238 -2687.703)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_440",
  "data-name": "Path 440",
  d: "M483.043,2715.777a.059.059,0,0,1-.02,0,2.746,2.746,0,0,1-.97-.6.057.057,0,0,1-.017-.041.059.059,0,0,1,.057-.06.062.062,0,0,1,.042.015,2.637,2.637,0,0,0,.928.57.055.055,0,0,1,.031.025.059.059,0,0,1-.013.075.058.058,0,0,1-.038.014Z",
  transform: "translate(-477.856 -2662.442)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_441",
  "data-name": "Path 441",
  d: "M1596.389,654.321a1.947,1.947,0,0,0,1.883-.785s8.841,3,10.515,10.966l1.762,5.623s-4.769,3.263-14.409,2.985Z",
  transform: "translate(-1568.325 -644.636)",
  fill: "#34728c"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_442",
  "data-name": "Path 442",
  d: "M1594.572,670.468q-.56,0-1.145-.017a.058.058,0,0,1-.041-.018.057.057,0,0,1-.017-.041l.249-18.789a.058.058,0,0,1,.006-.026.06.06,0,0,1,.017-.02.058.058,0,0,1,.051-.01h0a1.909,1.909,0,0,0,1.823-.766.06.06,0,0,1,.064-.017,19.827,19.827,0,0,1,4.645,2.5,16.672,16.672,0,0,1,3.549,3.408,12.719,12.719,0,0,1,2.359,5.1l1.762,5.62a.062.062,0,0,1,0,.037.058.058,0,0,1-.022.029,15.534,15.534,0,0,1-3.6,1.6A31.41,31.41,0,0,1,1594.572,670.468Zm-1.084-.133a31.965,31.965,0,0,0,10.741-1.387,15.939,15.939,0,0,0,3.538-1.566l-1.749-5.581V661.8a14.255,14.255,0,0,0-5.859-8.435,19.99,19.99,0,0,0-4.581-2.474,2.051,2.051,0,0,1-1.844.785Z",
  transform: "translate(-1565.613 -641.918)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_443",
  "data-name": "Path 443",
  d: "M2018.258,1106.976a.062.062,0,0,1-.029-.008.06.06,0,0,1-.021-.021.057.057,0,0,1,0-.058,20.733,20.733,0,0,0,2.113-7.648c.073-.513.148-1.044.231-1.576a.062.062,0,0,1,.024-.039.06.06,0,0,1,.094.057c-.083.531-.157,1.061-.231,1.574a20.887,20.887,0,0,1-2.127,7.69.06.06,0,0,1-.023.022A.058.058,0,0,1,2018.258,1106.976Z",
  transform: "translate(-1981.43 -1079.292)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_444",
  "data-name": "Path 444",
  d: "M1713.137,1503.9a.064.064,0,0,1-.028-.007c-.86-.466-1.748-.905-2.64-1.306a.057.057,0,0,1-.021-.012.061.061,0,0,1-.014-.02.063.063,0,0,1,0-.024.065.065,0,0,1,.005-.024.059.059,0,0,1,.082-.027c.895.4,1.786.842,2.649,1.31a.058.058,0,0,1,.029.066.061.061,0,0,1-.021.032.059.059,0,0,1-.036.012Z",
  transform: "translate(-1680.19 -1475.56)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_445",
  "data-name": "Path 445",
  d: "M1643.9,667.681l-.016,0a.059.059,0,0,1-.039-.073,25.562,25.562,0,0,0,.921-4.683.06.06,0,0,1,.021-.04.059.059,0,0,1,.043-.014.057.057,0,0,1,.022.006.061.061,0,0,1,.018.014.055.055,0,0,1,.011.02.054.054,0,0,1,0,.023,25.878,25.878,0,0,1-.927,4.705.06.06,0,0,1-.021.031.059.059,0,0,1-.036.012Z",
  transform: "translate(-1615.017 -653.771)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_446",
  "data-name": "Path 446",
  d: "M1709,692.55h-.015a.059.059,0,0,1-.042-.072,48.606,48.606,0,0,0,1.365-7.308.055.055,0,0,1,.007-.022.056.056,0,0,1,.015-.018.058.058,0,0,1,.043-.013.058.058,0,0,1,.022.007.055.055,0,0,1,.017.015.065.065,0,0,1,.011.021.066.066,0,0,1,0,.023,48.708,48.708,0,0,1-1.368,7.325.058.058,0,0,1-.022.03A.057.057,0,0,1,1709,692.55Z",
  transform: "translate(-1678.73 -675.547)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_447",
  "data-name": "Path 447",
  d: "M1760.935,772.418a.055.055,0,0,1-.025-.006.056.056,0,0,1-.019-.013.058.058,0,0,1-.012-.02.054.054,0,0,1,0-.023.062.062,0,0,1,.005-.022,29.706,29.706,0,0,0,2.943-10.923.062.062,0,0,1,.006-.022.059.059,0,0,1,.033-.03.061.061,0,0,1,.023,0,.063.063,0,0,1,.022.006.06.06,0,0,1,.03.033.06.06,0,0,1,0,.023,29.826,29.826,0,0,1-2.954,10.968.058.058,0,0,1-.021.024.06.06,0,0,1-.031.01Z",
  transform: "translate(-1729.566 -750.167)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_448",
  "data-name": "Path 448",
  d: "M1874.746,904.583a.061.061,0,0,1-.05-.028.058.058,0,0,1-.009-.028.062.062,0,0,1,.006-.029c1.367-2.8,2.76-10.295,3.368-14.282a.059.059,0,1,1,.118.018c-.609,3.992-2.005,11.5-3.378,14.314a.059.059,0,0,1-.054.034Z",
  transform: "translate(-1840.962 -876.246)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_449",
  "data-name": "Path 449",
  d: "M1619.245,743.251h-.015a20.244,20.244,0,0,0-6.686-.762.06.06,0,0,1-.043-.014.058.058,0,0,1-.021-.04.066.066,0,0,1,0-.023.057.057,0,0,1,.011-.02.052.052,0,0,1,.018-.014.057.057,0,0,1,.022-.006,20.364,20.364,0,0,1,6.725.765.06.06,0,0,1,.043.064.061.061,0,0,1-.019.037.059.059,0,0,1-.039.015Z",
  transform: "translate(-1584.318 -731.54)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_450",
  "data-name": "Path 450",
  d: "M1691.471,859.332h-.012a28.83,28.83,0,0,0-7.361-.5.059.059,0,0,1-.042-.015.058.058,0,0,1-.02-.041.059.059,0,0,1,.055-.062,28.943,28.943,0,0,1,7.391.507.059.059,0,0,1,.04.021.06.06,0,0,1-.008.083.061.061,0,0,1-.043.013Z",
  transform: "translate(-1654.356 -845.406)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_451",
  "data-name": "Path 451",
  d: "M1756.354,982.908h-.012a29.194,29.194,0,0,0-8.147-.5.059.059,0,0,1-.063-.054.061.061,0,0,1,.014-.043.06.06,0,0,1,.018-.014.057.057,0,0,1,.022-.006,29.3,29.3,0,0,1,8.18.5.059.059,0,0,1,.053.064.059.059,0,0,1-.065.053Z",
  transform: "translate(-1717.091 -966.327)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_452",
  "data-name": "Path 452",
  d: "M1806.368,1127.989l-.015,0a22.319,22.319,0,0,0-6.464-.674.059.059,0,0,1-.046-.1.057.057,0,0,1,.041-.019,22.437,22.437,0,0,1,6.5.678.056.056,0,0,1,.021.01.062.062,0,0,1,.016.017.061.061,0,0,1,.007.044.057.057,0,0,1-.021.032.056.056,0,0,1-.036.013Z",
  transform: "translate(-1767.691 -1108.227)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_453",
  "data-name": "Path 453",
  d: "M1845.207,1459.4h-.015a22.3,22.3,0,0,0-6.463-.676.058.058,0,0,1-.042-.016.059.059,0,0,1-.019-.041.06.06,0,0,1,.016-.042.059.059,0,0,1,.041-.019,22.432,22.432,0,0,1,6.5.677.059.059,0,0,1,.039.022.059.059,0,0,1-.01.083.059.059,0,0,1-.044.012Z",
  transform: "translate(-1805.707 -1432.603)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_454",
  "data-name": "Path 454",
  d: "M2171.548,1297.868a.057.057,0,0,1-.022,0,.063.063,0,0,1-.02-.013.056.056,0,0,1-.013-.02.047.047,0,0,1,0-.023.057.057,0,0,1,0-.023,20.026,20.026,0,0,0,1.216-4.006.051.051,0,0,1,.009-.021.062.062,0,0,1,.016-.016.067.067,0,0,1,.021-.009.066.066,0,0,1,.023,0,.065.065,0,0,1,.021.009.07.07,0,0,1,.016.016.063.063,0,0,1,.008.021.06.06,0,0,1,0,.023,20.225,20.225,0,0,1-1.223,4.028.064.064,0,0,1-.021.027A.058.058,0,0,1,2171.548,1297.868Z",
  transform: "translate(-2131.468 -1271.25)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_455",
  "data-name": "Path 455",
  d: "M1734.287,1420.6h-.01a61.83,61.83,0,0,0-10.759-.766.057.057,0,0,1-.023,0,.063.063,0,0,1-.019-.012.062.062,0,0,1-.013-.019.054.054,0,0,1,0-.022.058.058,0,0,1,0-.023.06.06,0,0,1,.013-.02.059.059,0,0,1,.041-.018,61.948,61.948,0,0,1,10.78.767.06.06,0,0,1,.04.021.058.058,0,0,1,.014.043.06.06,0,0,1-.021.04.058.058,0,0,1-.043.014Z",
  transform: "translate(-1692.942 -1394.558)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_456",
  "data-name": "Path 456",
  d: "M1381.96,667.444a9.422,9.422,0,0,0-4.633,6.117c-1.046,4.416.631,8.057.392,11.442a21.712,21.712,0,0,1-.739,4.861,39.728,39.728,0,0,1,4.324,1.971c1.78,1,2.281.9,2.815-.779s3.881-9.606,2.1-14.925S1382.064,671.624,1381.96,667.444Z",
  transform: "translate(-1353.814 -658.249)",
  fill: "#dc5c3f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_457",
  "data-name": "Path 457",
  d: "M1378.8,688.487a3.965,3.965,0,0,1-1.7-.652,39.6,39.6,0,0,0-4.311-1.964.087.087,0,0,1-.048-.045.089.089,0,0,1,0-.066,21.775,21.775,0,0,0,.736-4.839,19.384,19.384,0,0,0-.333-4.173,18.236,18.236,0,0,1-.059-7.282,9.613,9.613,0,0,1,2.734-4.758,8.307,8.307,0,0,1,1.947-1.418.087.087,0,0,1,.043-.009.089.089,0,0,1,.041.013.089.089,0,0,1,.042.073,5.373,5.373,0,0,0,1.626,4.032,12.384,12.384,0,0,1,2.629,4.63,15.485,15.485,0,0,1,.048,7.835,44.883,44.883,0,0,1-1.854,6.3c-.13.363-.235.651-.3.849-.274.863-.538,1.274-.91,1.421a.9.9,0,0,1-.333.058Zm-5.868-2.752a38.855,38.855,0,0,1,4.257,1.946c1,.559,1.523.722,1.88.581.317-.125.55-.5.808-1.31.064-.2.167-.49.3-.855.919-2.56,3.361-9.36,1.8-14.016a12.257,12.257,0,0,0-2.6-4.57,5.541,5.541,0,0,1-1.664-4,8.768,8.768,0,0,0-1.784,1.328,9.439,9.439,0,0,0-2.679,4.666,18.064,18.064,0,0,0,.062,7.216,19.541,19.541,0,0,1,.334,4.212A23.523,23.523,0,0,1,1372.935,685.735Z",
  transform: "translate(-1349.661 -654.172)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_458",
  "data-name": "Path 458",
  d: "M1448.326,699.705h-.012a.04.04,0,0,1-.013-.008.038.038,0,0,1-.009-.012.039.039,0,0,1,0-.015.037.037,0,0,1,0-.015,9.718,9.718,0,0,1,3.114-4.343.039.039,0,0,1,.055.01.038.038,0,0,1,.006.029.04.04,0,0,1-.016.025,9.639,9.639,0,0,0-3.085,4.306.039.039,0,0,1-.016.018A.041.041,0,0,1,1448.326,699.705Z",
  transform: "translate(-1423.61 -685.518)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_459",
  "data-name": "Path 459",
  d: "M1671.04,617.56s4.862-1.228,6.417.027,2.707,2.877,4.59,8.946l-1.36.3S1678.751,620.883,1671.04,617.56Z",
  transform: "translate(-1641.636 -608.897)",
  fill: "#dc5c3f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_460",
  "data-name": "Path 460",
  d: "M1676.64,622.736a.089.089,0,0,1-.052-.017.085.085,0,0,1-.032-.044,12.916,12.916,0,0,0-1.923-3.372,18.965,18.965,0,0,0-7.674-5.849.088.088,0,0,1-.053-.088.088.088,0,0,1,.066-.078c.2-.051,4.923-1.224,6.494.044,1.618,1.307,2.777,3.056,4.618,8.988a.091.091,0,0,1,0,.036.084.084,0,0,1-.011.034.087.087,0,0,1-.024.027.094.094,0,0,1-.033.015l-1.36.3Zm-9.368-9.338a20.4,20.4,0,0,1,4.537,2.757,17.813,17.813,0,0,1,2.969,3.048,13.592,13.592,0,0,1,1.918,3.342l1.191-.264c-1.811-5.816-2.949-7.533-4.532-8.812-1.3-1.05-5.064-.3-6.083-.07Z",
  transform: "translate(-1637.59 -604.709)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_461",
  "data-name": "Path 461",
  d: "M2134.8,1277.77a65.042,65.042,0,0,0,3.626,6.654c1.308,1.813-5.77,3.331-5.77,3.331l-.9-9.169Z",
  transform: "translate(-2092.572 -1255.627)",
  fill: "#dc5c3f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_462",
  "data-name": "Path 462",
  d: "M2128.583,1283.759a.086.086,0,0,1-.052-.018.091.091,0,0,1-.025-.027.094.094,0,0,1-.011-.035l-.9-9.169a.089.089,0,0,1,.065-.094l3.048-.815a.088.088,0,0,1,.1.047,65.25,65.25,0,0,0,3.618,6.64.8.8,0,0,1,.123.792c-.582,1.511-5.729,2.629-5.946,2.676l-.019,0Zm-.807-9.192.885,9c.72-.163,5.215-1.231,5.721-2.546a.629.629,0,0,0-.1-.628,63.481,63.481,0,0,1-3.6-6.6Z",
  transform: "translate(-2088.502 -1251.543)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_463",
  "data-name": "Path 463",
  d: "M1436.21,1525.744a17.825,17.825,0,0,1-3.479-1.518c-.174-.113-.205-.165-.213-.2a27.812,27.812,0,0,1,1.154-3.447.058.058,0,0,1,.013-.02.063.063,0,0,1,.02-.013.057.057,0,0,1,.024,0,.055.055,0,0,1,.023.006,30.412,30.412,0,0,0,3.974,1.715.06.06,0,0,1,.021.011.061.061,0,0,1,.015.019.063.063,0,0,1,.006.023.059.059,0,0,1,0,.024c0,.009-.32.84-.661,1.667-.7,1.7-.813,1.727-.873,1.74l-.02,0Zm-2.454-5.067a27.872,27.872,0,0,0-1.125,3.322,7.717,7.717,0,0,0,1.733.918,11.423,11.423,0,0,0,1.832.71h0a21.469,21.469,0,0,0,1.43-3.275A32.746,32.746,0,0,1,1433.756,1520.677Z",
  transform: "translate(-1408.171 -1493.243)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_464",
  "data-name": "Path 464",
  d: "M1477.636,1570.3a.057.057,0,0,1-.029-.008l-.444-.251a.059.059,0,0,1-.028-.035.06.06,0,0,1,.006-.045.059.059,0,0,1,.08-.022l.445.251a.058.058,0,0,1,.025.028.059.059,0,0,1,0,.038.061.061,0,0,1-.021.032.06.06,0,0,1-.036.012Z",
  transform: "translate(-1451.842 -1541.592)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_465",
  "data-name": "Path 465",
  d: "M1517.7,1591.2a.049.049,0,0,1-.02,0l-.6-.215a.06.06,0,0,1-.034-.03.059.059,0,0,1,.073-.081l.6.217a.062.062,0,0,1,.031.026.06.06,0,0,1,.007.04.058.058,0,0,1-.02.035.059.059,0,0,1-.038.014Z",
  transform: "translate(-1490.9 -1562.082)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_466",
  "data-name": "Path 466",
  d: "M1568.975,1610.666l-.019,0-.628-.207a.063.063,0,0,1-.034-.029.059.059,0,0,1,0-.045.058.058,0,0,1,.029-.034.059.059,0,0,1,.045,0l.628.207a.064.064,0,0,1,.021.011.057.057,0,0,1,.015.018.067.067,0,0,1,.007.023.057.057,0,0,1,0,.023.059.059,0,0,1-.058.041Z",
  transform: "translate(-1541.064 -1581.143)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_467",
  "data-name": "Path 467",
  d: "M1621.546,1630.022a.057.057,0,0,1-.021,0l-.488-.185a.059.059,0,0,1-.019-.012.054.054,0,0,1-.013-.019.051.051,0,0,1-.005-.022.06.06,0,0,1,.016-.042.069.069,0,0,1,.019-.013.062.062,0,0,1,.022-.005.06.06,0,0,1,.023,0l.488.187a.054.054,0,0,1,.019.012.057.057,0,0,1,.013.019.059.059,0,0,1,0,.022.064.064,0,0,1,0,.023.061.061,0,0,1-.022.027A.062.062,0,0,1,1621.546,1630.022Z",
  transform: "translate(-1592.656 -1600.109)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_468",
  "data-name": "Path 468",
  d: "M1470.21,2070.768a3.428,3.428,0,0,1-1.546-.368.06.06,0,0,1-.026-.08.058.058,0,0,1,.034-.029.057.057,0,0,1,.045,0,3.367,3.367,0,0,0,1.782.343.052.052,0,0,1,.023,0,.057.057,0,0,1,.02.011.06.06,0,0,1,.015.018.062.062,0,0,1,0,.045.051.051,0,0,1-.011.02.058.058,0,0,1-.018.014.067.067,0,0,1-.022.007C1470.41,2070.763,1470.31,2070.768,1470.21,2070.768Z",
  transform: "translate(-1443.521 -2031.332)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_469",
  "data-name": "Path 469",
  d: "M2182.11,2048.179a.056.056,0,0,1-.023,0,.059.059,0,0,1-.019-.012.054.054,0,0,1-.013-.019.055.055,0,0,1-.005-.022.061.061,0,0,1,0-.022.065.065,0,0,1,.012-.02.08.08,0,0,1,.019-.013.065.065,0,0,1,.022,0l1.046-.066a.062.062,0,0,1,.023,0,.069.069,0,0,1,.02.011.055.055,0,0,1,.014.019.065.065,0,0,1,.006.022.06.06,0,0,1,0,.023.056.056,0,0,1-.011.02.059.059,0,0,1-.019.014.057.057,0,0,1-.022.006l-1.046.066Z",
  transform: "translate(-2141.803 -2009.512)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_470",
  "data-name": "Path 470",
  d: "M2341.084,2458.377h-1.045a.058.058,0,0,1-.042-.017.061.061,0,0,1-.017-.042.058.058,0,0,1,.059-.059h1.046a.06.06,0,0,1,.042.017.059.059,0,0,1,0,.083.056.056,0,0,1-.042.017Z",
  transform: "translate(-2296.384 -2411.073)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_471",
  "data-name": "Path 471",
  d: "M2343.418,2432.078h-.139a.057.057,0,0,1-.041-.017.058.058,0,0,1,0-.083.057.057,0,0,1,.041-.017h.139a.059.059,0,0,1,.042.017.059.059,0,0,1-.042.1Z",
  transform: "translate(-2299.555 -2385.331)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_472",
  "data-name": "Path 472",
  d: "M1875.36,1640.149a.057.057,0,0,1-.029-.008.056.056,0,0,1-.022-.021,5.028,5.028,0,0,1-.635-1.694.053.053,0,0,1,0-.024.059.059,0,0,1,.009-.022.054.054,0,0,1,.017-.017.059.059,0,0,1,.022-.009.062.062,0,0,1,.024,0,.065.065,0,0,1,.021.01.063.063,0,0,1,.016.018.056.056,0,0,1,.008.022,4.917,4.917,0,0,0,.62,1.655.056.056,0,0,1,.009.029.058.058,0,0,1-.008.03.061.061,0,0,1-.022.022.058.058,0,0,1-.03.008Z",
  transform: "translate(-1840.948 -1608.561)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_473",
  "data-name": "Path 473",
  d: "M1970.613,1557.393a.014.014,0,0,1-.013-.015.017.017,0,0,1,0-.01.017.017,0,0,1,.009-.005,8.114,8.114,0,0,0,2.65-.622h.011l0,0a.01.01,0,0,1,0,0,.014.014,0,0,1,0,.011.014.014,0,0,1-.008.008,8.127,8.127,0,0,1-2.66.624Z",
  transform: "translate(-1934.84 -1528.678)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_474",
  "data-name": "Path 474",
  d: "M1555.976,656.5s-1.406.3-1.147,4.175c0,0,1.913-.193,2.324.148s.244,2.646.244,2.646l3.891,5.193a14.907,14.907,0,0,0-2.057-6.766c-1.7-2.611-2.484-2.911-2.955-4.568a6.933,6.933,0,0,0-.3-.827Z",
  transform: "translate(-1527.859 -647.533)",
  fill: "#dc5c3f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_475",
  "data-name": "Path 475",
  d: "M1558.559,665.99a.057.057,0,0,1-.047-.024l-3.889-5.192a.061.061,0,0,1-.012-.039c.046-.633.1-2.333-.222-2.6a5.356,5.356,0,0,0-2.281-.134.06.06,0,0,1-.044-.014.061.061,0,0,1-.015-.018.066.066,0,0,1-.006-.023c-.26-3.878,1.134-4.224,1.193-4.237a.058.058,0,0,1,.066.034,6.945,6.945,0,0,1,.3.835,5.917,5.917,0,0,0,1.316,2.3,27.751,27.751,0,0,1,1.631,2.251,15.074,15.074,0,0,1,2.067,6.8.058.058,0,0,1-.01.035.06.06,0,0,1-.029.022Zm-3.831-5.27,3.761,5.019a14.812,14.812,0,0,0-2.037-6.543,27.589,27.589,0,0,0-1.625-2.243,6,6,0,0,1-1.337-2.341,6.875,6.875,0,0,0-.275-.77,1.306,1.306,0,0,0-.6.607,6.315,6.315,0,0,0-.464,3.431c.337-.031,1.919-.155,2.307.166C1554.874,658.388,1554.751,660.4,1554.729,660.72Z",
  transform: "translate(-1525.132 -644.807)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_476",
  "data-name": "Path 476",
  d: "M1655.53,617.362s3.034.192,4.394,1.308a4.058,4.058,0,0,0-.392,1c-.028.323,1.538-.235,1.538-.235a18.979,18.979,0,0,1,4.563,7.254v.593s-4.188-5.824-6.256-7.068-3.217-1.651-3.44-2.087S1655.53,617.362,1655.53,617.362Z",
  transform: "translate(-1626.455 -609.229)",
  fill: "#dc5c3f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_477",
  "data-name": "Path 477",
  d: "M1662.99,624.622a.058.058,0,0,1-.027-.007.064.064,0,0,1-.021-.018c-.042-.059-4.206-5.829-6.239-7.052-.819-.493-1.487-.851-2.024-1.138-.836-.447-1.295-.693-1.437-.973-.218-.43-.4-.762-.406-.765a.059.059,0,0,1-.008-.03.062.062,0,0,1,.009-.03.061.061,0,0,1,.023-.021.06.06,0,0,1,.031-.006c.125.008,3.069.206,4.428,1.321a.059.059,0,0,1,.014.073,4,4,0,0,0-.384.981c0,.009,0,.011.005.015a3.6,3.6,0,0,0,1.454-.31.058.058,0,0,1,.031,0,.057.057,0,0,1,.028.014,19.219,19.219,0,0,1,4.578,7.279.052.052,0,0,1,0,.019v.593a.059.059,0,0,1-.01.034.058.058,0,0,1-.029.022A.053.053,0,0,1,1662.99,624.622Zm-10-9.914c.071.13.206.379.353.674.125.246.6.5,1.388.922.538.288,1.208.646,2.03,1.141,1.87,1.125,5.5,6.023,6.168,6.938v-.4a19.145,19.145,0,0,0-4.518-7.2c-.283.1-1.317.446-1.53.281a.129.129,0,0,1-.041-.052.131.131,0,0,1-.01-.066,3.674,3.674,0,0,1,.376-.981C1656.006,615.016,1653.538,614.755,1652.992,614.708Z",
  transform: "translate(-1623.811 -606.508)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_478",
  "data-name": "Path 478",
  d: "M1422.732,900.331h-.015a.055.055,0,0,1-.021-.01.058.058,0,0,1-.023-.039.061.061,0,0,1,0-.023,3.735,3.735,0,0,1,1.633-2.114.059.059,0,0,1,.022-.009.058.058,0,0,1,.024,0,.061.061,0,0,1,.022.01.058.058,0,0,1,.016.018.062.062,0,0,1,.007.023.057.057,0,0,1,0,.024.061.061,0,0,1-.012.021.063.063,0,0,1-.02.015,3.61,3.61,0,0,0-1.576,2.04.059.059,0,0,1-.057.044Z",
  transform: "translate(-1398.538 -884.045)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_479",
  "data-name": "Path 479",
  d: "M1409.673,1114.33a.059.059,0,0,1-.053-.033,7.924,7.924,0,0,1-.5-2.323.056.056,0,0,1,0-.023.061.061,0,0,1,.011-.02.058.058,0,0,1,.018-.014.053.053,0,0,1,.022-.006.059.059,0,0,1,.043.014.058.058,0,0,1,.02.04,7.97,7.97,0,0,0,.488,2.279.06.06,0,0,1-.026.079.057.057,0,0,1-.026.007Z",
  transform: "translate(-1385.273 -1093.287)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_480",
  "data-name": "Path 480",
  d: "M1490.37,883.762s4.665,5.173,9.865,4.144,8.426-6.019,9.437-7.135a47.8,47.8,0,0,0-4.464-4.847s-3.88,5.2-5.719,5.034c-2.655-.244-5.615-7.094-7.723-6.815Z",
  transform: "translate(-1464.798 -860.554)",
  fill: "#dc5c3f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_481",
  "data-name": "Path 481",
  d: "M1860.79,1475.515a4.058,4.058,0,0,1-.849-.094.055.055,0,0,1-.021-.009.058.058,0,0,1-.024-.038.067.067,0,0,1,0-.023.068.068,0,0,1,.01-.021.063.063,0,0,1,.016-.016.056.056,0,0,1,.022-.008.058.058,0,0,1,.023,0c.015,0,1.538.353,2.067-.37a.058.058,0,0,1,.016-.016.054.054,0,0,1,.022-.008.062.062,0,0,1,.024,0,.06.06,0,0,1,.021.01.059.059,0,0,1,.022.063.062.062,0,0,1-.011.021A1.619,1.619,0,0,1,1860.79,1475.515Z",
  transform: "translate(-1826.484 -1448.586)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_482",
  "data-name": "Path 482",
  d: "M658.113,271.315a.059.059,0,0,1-.058-.051.058.058,0,0,1,.009-.04.059.059,0,0,1,.033-.025,6.659,6.659,0,0,0,1.914-.986,2.987,2.987,0,0,0,1.279-3.322c-.518-1.969-2.576-1.933-4.755-1.894a13.822,13.822,0,0,1-3.21-.186,3.5,3.5,0,0,1-2.423-1.676c-1.312-2.29,1.5-4.149,4.212-5.946,1.962-1.3,3.993-2.643,4.357-4.1a2.575,2.575,0,0,0-1.283-2.961,16.009,16.009,0,0,0-3.921-1.618c-1.883-.6-3.662-1.166-4.055-2.21a1.67,1.67,0,0,1,.258-1.487,19.085,19.085,0,0,1,7.748-7.018,33.069,33.069,0,0,1,9.583-3.084,49.606,49.606,0,0,1,11.593-.6.059.059,0,0,1,.053.064.059.059,0,0,1-.064.053,49.4,49.4,0,0,0-11.564.6c-5.7.993-13.325,3.542-17.248,10.047a1.562,1.562,0,0,0-.249,1.385c.373.99,2.125,1.548,3.981,2.139,2.8.893,5.984,1.905,5.282,4.72-.374,1.506-2.422,2.861-4.406,4.174a19.791,19.791,0,0,0-3.591,2.761c-.968,1.072-1.154,2.034-.583,3.029,1.079,1.883,3.341,1.844,5.529,1.8,2.227-.039,4.329-.078,4.87,1.982a3.131,3.131,0,0,1-1.324,3.447,6.79,6.79,0,0,1-1.949,1Z",
  transform: "translate(-642.385 -234)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_483",
  "data-name": "Path 483",
  d: "M2202.809,2069.318a.041.041,0,0,1-.028-.012.039.039,0,0,1-.012-.028.04.04,0,0,1,.012-.028.039.039,0,0,1,.028-.011l.442-.023a.038.038,0,0,1,.029.01.038.038,0,0,1,.013.027.04.04,0,0,1-.01.028.044.044,0,0,1-.027.013l-.442.023Z",
  transform: "translate(-2162.084 -2030.283)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_484",
  "data-name": "Path 484",
  d: "M1480.378,2104.347a1.945,1.945,0,0,1-.857-.2.039.039,0,0,1-.019-.022.038.038,0,0,1,0-.03.04.04,0,0,1,.022-.02.038.038,0,0,1,.029,0,1.861,1.861,0,0,0,1,.182h.015l.014.007a.043.043,0,0,1,.01.012.041.041,0,0,1,0,.015.039.039,0,0,1-.009.028.041.041,0,0,1-.026.014C1480.5,2104.343,1480.441,2104.347,1480.378,2104.347Z",
  transform: "translate(-1454.159 -2064.4)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_485",
  "data-name": "Path 485",
  d: "M1505.959,2130.469h-.139a.039.039,0,0,1-.028-.012.039.039,0,0,1,0-.055.04.04,0,0,1,.028-.012h.139a.04.04,0,0,1,.028.012.039.039,0,0,1,0,.055A.039.039,0,0,1,1505.959,2130.469Z",
  transform: "translate(-1479.881 -2090.158)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_486",
  "data-name": "Path 486",
  d: "M460.636,2724.042h-.011a1.2,1.2,0,0,1-.632-.446.031.031,0,0,1-.006-.013.04.04,0,0,1,0-.015.043.043,0,0,1,.005-.015.047.047,0,0,1,.011-.011.039.039,0,0,1,.029-.006.037.037,0,0,1,.025.015,1.121,1.121,0,0,0,.59.416.037.037,0,0,1,.014.007.035.035,0,0,1,.01.012.04.04,0,0,1,0,.014.036.036,0,0,1-.016.035A.035.035,0,0,1,460.636,2724.042Z",
  transform: "translate(-456.273 -2670.72)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_487",
  "data-name": "Path 487",
  d: "M1196.949,2742.075a.041.041,0,0,1-.018,0l-.233-.118a.039.039,0,0,1-.02-.023.041.041,0,0,1,0-.03.042.042,0,0,1,.023-.019.039.039,0,0,1,.03,0l.233.118a.039.039,0,0,1,.019.023.041.041,0,0,1,0,.031.048.048,0,0,1-.015.015.047.047,0,0,1-.021.006Z",
  transform: "translate(-1177.336 -2688.675)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_488",
  "data-name": "Path 488",
  d: "M721.056,2053.689h-.01a6.029,6.029,0,0,1-1.339-.529.042.042,0,0,1-.019-.023.041.041,0,0,1,0-.031.035.035,0,0,1,.01-.011.038.038,0,0,1,.014-.008.036.036,0,0,1,.015,0,.044.044,0,0,1,.015,0,5.931,5.931,0,0,0,1.322.522.041.041,0,0,1,.026.015.04.04,0,0,1-.007.056.039.039,0,0,1-.029.008Z",
  transform: "translate(-710.465 -2014.495)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_489",
  "data-name": "Path 489",
  d: "M756.252,2083.578a.361.361,0,0,1-.2-.059.041.041,0,0,1-.017-.025.039.039,0,0,1,.005-.029.034.034,0,0,1,.011-.011l.014-.006h.015l.014.006a.284.284,0,0,0,.109.042.276.276,0,0,0,.117-.006.04.04,0,0,1,.015,0,.038.038,0,0,1,.015,0,.05.05,0,0,1,.012.01.039.039,0,0,1,.008.029.035.035,0,0,1,0,.014.036.036,0,0,1-.01.012.04.04,0,0,1-.014.007A.354.354,0,0,1,756.252,2083.578Z",
  transform: "translate(-746.045 -2044.211)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_490",
  "data-name": "Path 490",
  d: "M984.091,2306.552a7.155,7.155,0,0,1-1.156-.094.039.039,0,0,1-.025-.016.039.039,0,0,1,.009-.054.044.044,0,0,1,.029-.007,7.029,7.029,0,0,0,1.667.074.039.039,0,0,1,.029.01.039.039,0,0,1,.014.027.039.039,0,0,1-.036.042C984.445,2306.545,984.267,2306.552,984.091,2306.552Z",
  transform: "translate(-968.097 -2262.415)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_491",
  "data-name": "Path 491",
  d: "M939.666,2298.163h0l-.395-.07a.035.035,0,0,1-.014-.006.04.04,0,0,1-.011-.01.044.044,0,0,1-.006-.014.041.041,0,0,1,0-.015.04.04,0,0,1,.016-.025l.014-.006h.015l.4.071a.041.041,0,0,1,.027.014.04.04,0,0,1,.009.029.039.039,0,0,1-.043.035Z",
  transform: "translate(-925.355 -2254.228)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_492",
  "data-name": "Path 492",
  d: "M2239.921,982.253a.016.016,0,0,1-.009,0l-.647-.54a.017.017,0,0,1,0-.01.015.015,0,0,1,0-.01.013.013,0,0,1,.009-.005.014.014,0,0,1,.01,0l.647.54a.017.017,0,0,1,.005.01.017.017,0,0,1,0,.011l-.005,0Z",
  transform: "translate(-2197.801 -965.823)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_493",
  "data-name": "Path 493",
  d: "M2268.8,989.761a.014.014,0,0,1-.009,0l-.209-.163,0,0a.014.014,0,0,1,0-.006.011.011,0,0,1,0-.006l0-.005a.017.017,0,0,1,.01-.005.016.016,0,0,1,.011,0l.209.163a.016.016,0,0,1,0,.01.016.016,0,0,1,0,.011l-.005,0Z",
  transform: "translate(-2226.493 -973.54)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_494",
  "data-name": "Path 494",
  d: "M2256.629,961.109h-.006l0,0a.265.265,0,0,0-.175-.09h-.006l-.005,0a.013.013,0,0,1,0-.005.026.026,0,0,1,0-.006.014.014,0,0,1,0-.006l0,0,.006,0h.006a.3.3,0,0,1,.2.1.014.014,0,0,1,0,.021l-.006,0Z",
  transform: "translate(-2214.604 -945.561)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_495",
  "data-name": "Path 495",
  d: "M2291.1,1033.734a.017.017,0,0,1-.011,0l-.4-.417a.014.014,0,0,1,0-.01.013.013,0,0,1,0-.01.015.015,0,0,1,.01,0,.015.015,0,0,1,.01,0l.4.417a.01.01,0,0,1,0,0,.014.014,0,0,1,0,.005.015.015,0,0,1,0,.006l0,0,0,0Z",
  transform: "translate(-2248.138 -1016.332)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_496",
  "data-name": "Path 496",
  d: "M2306.107,1002.5a.014.014,0,0,1-.01,0l-.523-.546a.015.015,0,0,1,0-.01.018.018,0,0,1,0-.01.018.018,0,0,1,.011,0,.015.015,0,0,1,.01,0l.524.546,0,0a.015.015,0,0,1,0,.006.013.013,0,0,1,0,.005l0,0-.005,0Z",
  transform: "translate(-2262.704 -985.629)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_497",
  "data-name": "Path 497",
  d: "M2223.3,885.014l-.008,0a.012.012,0,0,1-.005-.006,1.178,1.178,0,0,1-.094-.636.014.014,0,0,1,.006-.01.015.015,0,0,1,.011,0,.016.016,0,0,1,.01.006.015.015,0,0,1,0,.011,1.143,1.143,0,0,0,.092.62.012.012,0,0,1,0,.011.015.015,0,0,1-.008.008l-.006,0Z",
  transform: "translate(-2182.068 -870.559)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_498",
  "data-name": "Path 498",
  d: "M2237.9,900.971a.014.014,0,0,1-.01,0,.014.014,0,0,1,0-.01v-.118a.017.017,0,0,1,0-.009.016.016,0,0,1,.01,0,.014.014,0,0,1,.009,0,.015.015,0,0,1,.005.009v.118a.016.016,0,0,1,0,.01.015.015,0,0,1-.011,0Z",
  transform: "translate(-2196.46 -886.679)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_499",
  "data-name": "Path 499",
  d: "M2235.555,929.574l-.008,0-.005-.005a.418.418,0,0,1-.048-.265.014.014,0,0,1,.017-.012.014.014,0,0,1,.01.006.015.015,0,0,1,0,.011.385.385,0,0,0,.045.246.021.021,0,0,1,0,.006.011.011,0,0,1,0,.006.014.014,0,0,1,0,.005l0,0Z",
  transform: "translate(-2194.111 -914.538)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_500",
  "data-name": "Path 500",
  d: "M1451.369,936.01l-.014,0a.042.042,0,0,1-.013-.008.04.04,0,0,1-.009-.013.037.037,0,0,1,0-.015.042.042,0,0,1,0-.015,3.119,3.119,0,0,1,.61-.978.04.04,0,0,1,.027-.011.039.039,0,0,1,.027.01.037.037,0,0,1,.013.026.04.04,0,0,1-.008.028,3.036,3.036,0,0,0-.595.953.039.039,0,0,1-.015.018A.038.038,0,0,1,1451.369,936.01Z",
  transform: "translate(-1426.587 -920.097)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_501",
  "data-name": "Path 501",
  d: "M2330.331,1137.7a.039.039,0,0,1-.015,0,.037.037,0,0,1-.013-.009l-.791-.813a.038.038,0,0,1,0-.055.039.039,0,0,1,.028-.011.04.04,0,0,1,.028.012l.791.814a.032.032,0,0,1,.008.013.034.034,0,0,1,0,.015.033.033,0,0,1,0,.015.035.035,0,0,1-.008.013A.041.041,0,0,1,2330.331,1137.7Z",
  transform: "translate(-2286.126 -1117.657)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_502",
  "data-name": "Path 502",
  d: "M2335.562,1162.9a.04.04,0,0,1-.027-.011l-.163-.163a.037.037,0,0,1-.009-.013.035.035,0,0,1,0-.015.037.037,0,0,1,0-.015.035.035,0,0,1,.009-.013.038.038,0,0,1,.055,0l.163.162a.04.04,0,0,1,.011.02.043.043,0,0,1,0,.023.04.04,0,0,1-.014.018.041.041,0,0,1-.022.006Z",
  transform: "translate(-2291.862 -1142.959)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_503",
  "data-name": "Path 503",
  d: "M2204.69,1696.913a.039.039,0,0,1-.029-.008.038.038,0,0,1-.014-.027.039.039,0,0,1,.008-.029.04.04,0,0,1,.026-.015,9.153,9.153,0,0,0,1.507-.5.037.037,0,0,1,.015,0,.042.042,0,0,1,.015,0,.04.04,0,0,1,.013.008.03.03,0,0,1,.009.013.035.035,0,0,1,0,.03.035.035,0,0,1-.008.013.042.042,0,0,1-.013.009,9.273,9.273,0,0,1-1.519.509Z",
  transform: "translate(-2163.921 -1665.306)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_504",
  "data-name": "Path 504",
  d: "M2260.874,1678.088a.073.073,0,0,1-.023,0,.062.062,0,0,1-.02-.011.054.054,0,0,1-.014-.018.056.056,0,0,1-.006-.022.049.049,0,0,1,0-.023.052.052,0,0,1,.011-.02.062.062,0,0,1,.019-.014.059.059,0,0,1,.022-.006,1.079,1.079,0,0,0,.419-.154.058.058,0,0,1,.022-.01.057.057,0,0,1,.023,0,.047.047,0,0,1,.022.009.061.061,0,0,1,.017.017.056.056,0,0,1,.008.022.065.065,0,0,1,0,.024.056.056,0,0,1-.01.021.059.059,0,0,1-.018.016,1.192,1.192,0,0,1-.465.171Z",
  transform: "translate(-2218.895 -1647.175)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_505",
  "data-name": "Path 505",
  d: "M1586.879,2479.589a.041.041,0,0,1-.028-.012.038.038,0,0,1-.011-.028.038.038,0,0,1,.011-.028.041.041,0,0,1,.028-.011h.93a.039.039,0,0,1,.039.039.039.039,0,0,1-.011.028.04.04,0,0,1-.028.012h-.93Z",
  transform: "translate(-1559.222 -2431.872)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_506",
  "data-name": "Path 506",
  d: "M1938.435,1572.316a.016.016,0,0,1-.01,0,.015.015,0,0,1-.005-.008.016.016,0,0,1,0-.011.016.016,0,0,1,.01-.006l.419-.078h.006l.005,0,0,0a.01.01,0,0,1,0,.005.012.012,0,0,1,0,.006.013.013,0,0,1,0,.005l0,0-.005,0-.418.079Z",
  transform: "translate(-1903.343 -1543.819)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_507",
  "data-name": "Path 507",
  d: "M2082.541,1520.344a.012.012,0,0,1-.009,0,.013.013,0,0,1-.006-.007.017.017,0,0,1,0-.011l0,0,0,0,1.168-.385h.005l.006,0,0,0a.012.012,0,0,1,0,.005.012.012,0,0,1,0,.006.015.015,0,0,1,0,.005l0,0-.005,0-1.168.385Z",
  transform: "translate(-2044.392 -1492.649)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_508",
  "data-name": "Path 508",
  d: "M1886.732,1600.484a.016.016,0,0,1-.009-.005.015.015,0,0,1,0-.01.016.016,0,0,1,0-.01.017.017,0,0,1,.009-.005l.209-.018h.006l.005,0,0,0a.012.012,0,0,1,0,.006.013.013,0,0,1,0,.011.016.016,0,0,1-.01.005l-.209.018Z",
  transform: "translate(-1852.74 -1571.448)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_509",
  "data-name": "Path 509",
  d: "M1998.722,1542.794a.013.013,0,0,1-.009,0,.015.015,0,0,1,0-.01.016.016,0,0,1,0-.01.015.015,0,0,1,.009-.005,2.28,2.28,0,0,0,.992-.231.016.016,0,0,1,.011,0,.014.014,0,0,1,.009.007.015.015,0,0,1,0,.011.015.015,0,0,1-.007.009A2.312,2.312,0,0,1,1998.722,1542.794Z",
  transform: "translate(-1962.354 -1514.773)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_510",
  "data-name": "Path 510",
  d: "M1879.7,1227.863h-.006a.037.037,0,0,1-.014-.005.034.034,0,0,1-.011-.01.032.032,0,0,1-.006-.014.035.035,0,0,1,0-.015,2.918,2.918,0,0,1,.746-1.537.043.043,0,0,1,.012-.009l.015,0a.042.042,0,0,1,.016,0,.043.043,0,0,1,.013.008.041.041,0,0,1,.009.012.04.04,0,0,1,0,.015.039.039,0,0,1,0,.015.041.041,0,0,1-.008.013,2.833,2.833,0,0,0-.724,1.495.038.038,0,0,1-.014.024A.04.04,0,0,1,1879.7,1227.863Z",
  transform: "translate(-1845.826 -1205.218)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_511",
  "data-name": "Path 511",
  d: "M1892.595,1281.069h-.009a.036.036,0,0,1-.014-.006.041.041,0,0,1-.01-.011.035.035,0,0,1-.005-.014.056.056,0,0,1,0-.016l.111-.471a.044.044,0,0,1,.006-.015.039.039,0,0,1,.011-.012.042.042,0,0,1,.015-.006.037.037,0,0,1,.016,0,.033.033,0,0,1,.014.007.043.043,0,0,1,.011.012.051.051,0,0,1,.005.015.053.053,0,0,1,0,.016l-.111.471a.039.039,0,0,1-.014.021A.039.039,0,0,1,1892.595,1281.069Z",
  transform: "translate(-1858.452 -1258.316)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_512",
  "data-name": "Path 512",
  d: "M1797.418,1576.245a.014.014,0,0,1-.009,0,.016.016,0,0,1-.005-.008.014.014,0,0,1,0-.011.015.015,0,0,1,.008-.007,4.984,4.984,0,0,1,1.827-.2h.006l.005,0,0,.005a.056.056,0,0,1,0,.006.011.011,0,0,1,0,.006l0,0-.006,0h-.006a4.951,4.951,0,0,0-1.816.193Z",
  transform: "translate(-1765.318 -1547.534)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_513",
  "data-name": "Path 513",
  d: "M1795.3,1612.329a.014.014,0,0,1-.014-.015.924.924,0,0,1,.727-.829h.006l.005,0,0,0a.013.013,0,0,1,0,.006.021.021,0,0,1,0,.005.012.012,0,0,1,0,.005l0,0-.005,0a.9.9,0,0,0-.7.8.01.01,0,0,1,0,.005l0,0,0,0Z",
  transform: "translate(-1763.249 -1582.262)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_514",
  "data-name": "Path 514",
  d: "M1768.175,1687.355h0a.014.014,0,0,1-.009-.006.017.017,0,0,1,0-.011,4.614,4.614,0,0,1,.424-1.223l0,0,.005,0h.011l0,0a.011.011,0,0,1,0,.005.014.014,0,0,1,0,.006.016.016,0,0,1,0,.005,4.6,4.6,0,0,0-.421,1.216.014.014,0,0,1,0,.008.017.017,0,0,1-.009,0Z",
  transform: "translate(-1736.695 -1655.3)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_515",
  "data-name": "Path 515",
  d: "M1779.852,1630.609h-.005l0,0,0,0a.009.009,0,0,1,0-.005.013.013,0,0,1,0-.006l.139-.384a.014.014,0,0,1,.008-.008.017.017,0,0,1,.011,0l.005,0,0,0a.012.012,0,0,1,0,.006.015.015,0,0,1,0,.006l-.14.384-.005.006a.014.014,0,0,1-.008,0Z",
  transform: "translate(-1748.125 -1600.578)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_516",
  "data-name": "Path 516",
  d: "M1763.33,1683.225h0l-.005,0,0,0a.013.013,0,0,1,0-.005.013.013,0,0,1,0-.006l.07-.349a.016.016,0,0,1,.007-.008.016.016,0,0,1,.01,0,.014.014,0,0,1,.009.006.014.014,0,0,1,0,.01l-.07.349a.018.018,0,0,1-.005.008.017.017,0,0,1-.009,0Z",
  transform: "translate(-1731.953 -1652.112)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_517",
  "data-name": "Path 517",
  d: "M1728.974,1757.738h-.005l-.005,0,0,0a.01.01,0,0,1,0-.005.018.018,0,0,1,0-.006l.372-1.015a.013.013,0,0,1,.008-.007.016.016,0,0,1,.011,0,.012.012,0,0,1,.008.007.015.015,0,0,1,0,.011l-.372,1.016a.017.017,0,0,1-.006.006l-.008,0Z",
  transform: "translate(-1698.327 -1724.392)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_518",
  "data-name": "Path 518",
  d: "M1755.124,1796.172a.014.014,0,0,1-.01,0,.013.013,0,0,1,0-.01v-.07a.029.029,0,0,1,0-.007.015.015,0,0,1,0-.006l.005,0h.013l0,0,0,.006a.02.02,0,0,1,0,.007v.07a.016.016,0,0,1,0,.01.016.016,0,0,1-.01,0Z",
  transform: "translate(-1723.921 -1762.931)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_519",
  "data-name": "Path 519",
  d: "M1921.2,1592.876a.014.014,0,0,1-.01,0,.012.012,0,0,1,0-.009.011.011,0,0,1,0-.006.011.011,0,0,1,0-.005l0,0h.006l.279-.031h.006l.005,0,0,0a.009.009,0,0,1,0,.005.012.012,0,0,1,0,.006l0,.005,0,0-.005,0-.28.031Z",
  transform: "translate(-1886.478 -1563.99)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_520",
  "data-name": "Path 520",
  d: "M2294.612,1017.586a.016.016,0,0,1-.009,0l-.452-.351a.015.015,0,0,1-.006-.01.015.015,0,0,1,0-.011s0,0,0,0h.011l.005,0,.452.351,0,0a.014.014,0,0,1,0,.005.015.015,0,0,1,0,.006l0,.005-.005,0Z",
  transform: "translate(-2251.522 -1000.591)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_521",
  "data-name": "Path 521",
  d: "M319.76,2240.781a.039.039,0,0,1-.022-.007,2.645,2.645,0,0,1-.85-.956.04.04,0,0,1,0-.03.039.039,0,0,1,.019-.023.039.039,0,0,1,.029,0,.04.04,0,0,1,.023.018,2.572,2.572,0,0,0,.824.928.034.034,0,0,1,.011.011.039.039,0,0,1,.006.013.045.045,0,0,1,0,.016.039.039,0,0,1-.006.014.038.038,0,0,1-.014.012A.036.036,0,0,1,319.76,2240.781Z",
  transform: "translate(-318.165 -2197.21)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_522",
  "data-name": "Path 522",
  d: "M1152.252,2320.681a.041.041,0,0,1-.024-.007.045.045,0,0,1-.014-.022.038.038,0,0,1,0-.025.037.037,0,0,1,.017-.019,3.784,3.784,0,0,0,1.567-1.648.046.046,0,0,1,.009-.012.037.037,0,0,1,.013-.007.032.032,0,0,1,.015,0,.035.035,0,0,1,.015,0,.036.036,0,0,1,.012.009.045.045,0,0,1,.008.013.038.038,0,0,1,0,.015.035.035,0,0,1,0,.015,3.864,3.864,0,0,1-1.6,1.682.032.032,0,0,1-.019,0Z",
  transform: "translate(-1133.815 -2274.707)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_523",
  "data-name": "Path 523",
  d: "M1142.43,2405.424a.038.038,0,0,1-.028-.01.039.039,0,0,1-.013-.027.038.038,0,0,1,.01-.028.037.037,0,0,1,.027-.013,3.28,3.28,0,0,0,1.4-.46.036.036,0,0,1,.015-.008.04.04,0,0,1,.017,0,.033.033,0,0,1,.016.006.036.036,0,0,1,.011.013.038.038,0,0,1,.005.016.04.04,0,0,1-.011.031.035.035,0,0,1-.014.009,3.345,3.345,0,0,1-1.431.471Z",
  transform: "translate(-1124.199 -2358.822)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_524",
  "data-name": "Path 524",
  d: "M1494.92,884.1a8.456,8.456,0,0,1-2.366-.353,12.288,12.288,0,0,1-3.17-1.483,16.522,16.522,0,0,1-3-2.472.089.089,0,0,1-.018-.062.088.088,0,0,1,.089-.08.088.088,0,0,1,.06.025,16.246,16.246,0,0,0,2.969,2.445,9.544,9.544,0,0,0,6.813,1.671c4.418-.875,7.385-4.608,8.811-6.4.214-.269.388-.488.528-.648a48.153,48.153,0,0,0-4.331-4.72c-.489.645-3.852,5-5.65,5a.723.723,0,0,1-.1,0c-1.385-.128-2.809-1.95-4.187-3.712-1.3-1.664-2.526-3.235-3.514-3.1a.088.088,0,0,1-.1-.076.09.09,0,0,1,.017-.065.089.089,0,0,1,.057-.034c1.088-.144,2.347,1.466,3.679,3.17,1.354,1.732,2.755,3.524,4.063,3.644,1.771.163,5.6-4.947,5.641-5a.088.088,0,0,1,.026-.023.091.091,0,0,1,.033-.011.085.085,0,0,1,.035,0,.091.091,0,0,1,.031.015,46.869,46.869,0,0,1,4.478,4.862.087.087,0,0,1,0,.115c-.144.157-.333.4-.571.7-1.439,1.811-4.434,5.578-8.914,6.466a7.289,7.289,0,0,1-1.412.136Z",
  transform: "translate(-1460.878 -856.523)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_525",
  "data-name": "Path 525",
  d: "M1788.76,1526.042a38.279,38.279,0,0,0,5.538-.942v.193l-1.668.493-3.672.549Z",
  transform: "translate(-1756.858 -1497.71)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_526",
  "data-name": "Path 526",
  d: "M1607.76,584.484l.112.248.976-.833-.531-.864Z",
  transform: "translate(-1579.698 -575.63)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_527",
  "data-name": "Path 527",
  d: "M1516.116,527.982l-.371-.8-1.976.337s.035.314.2,1.219a2.29,2.29,0,0,0-.085.619c0,.093.19.009.454.07l.145.235c.148-.055.544-.278.544-.278.009.358-.371.558-.353.584.078.109.136.262.3.262.774,0,1.623-.85,1.247-1.508a.581.581,0,0,0,.471-.567C1516.628,527.78,1516.26,527.868,1516.116,527.982Z",
  transform: "translate(-1487.702 -520.965)",
  fill: "#f6aa65"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_528",
  "data-name": "Path 528",
  d: "M1512.257,527.568a.364.364,0,0,1-.3-.222c-.014-.022-.028-.044-.042-.064-.037-.051.011-.091.06-.133a.752.752,0,0,0,.271-.38,5.07,5.07,0,0,1-.454.228.059.059,0,0,1-.071-.024l-.132-.213a1.113,1.113,0,0,0-.266-.017c-.1,0-.2.005-.21-.1a2.277,2.277,0,0,1,.084-.624c-.16-.888-.2-1.2-.2-1.209a.059.059,0,0,1,.049-.064l1.976-.337a.056.056,0,0,1,.037.006.056.056,0,0,1,.026.027l.342.734a.488.488,0,0,1,.392-.047.353.353,0,0,1,.214.3.627.627,0,0,1-.445.611.837.837,0,0,1-.072.785A1.55,1.55,0,0,1,1512.257,527.568Zm-.225-.317.02.032c.066.1.113.168.206.168a1.43,1.43,0,0,0,1.157-.688.715.715,0,0,0,.039-.732.058.058,0,0,1-.008-.026.056.056,0,0,1,0-.026.056.056,0,0,1,.015-.022.059.059,0,0,1,.024-.012.527.527,0,0,0,.427-.5.243.243,0,0,0-.14-.208.394.394,0,0,0-.339.07.058.058,0,0,1-.024.011.058.058,0,0,1-.05-.012.062.062,0,0,1-.016-.021l-.353-.756-1.876.32c.016.124.066.471.19,1.16a.06.06,0,0,1,0,.027,2.273,2.273,0,0,0-.083.588.721.721,0,0,0,.089,0,1.212,1.212,0,0,1,.319.025.059.059,0,0,1,.037.026l.118.192c.165-.073.487-.253.491-.255a.058.058,0,0,1,.058,0,.056.056,0,0,1,.021.021.055.055,0,0,1,.008.029.757.757,0,0,1-.322.576Z",
  transform: "translate(-1484.987 -518.242)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_529",
  "data-name": "Path 529",
  d: "M1539.888,593.843c.04-.019.048-.086.017-.15s-.086-.1-.126-.083-.047.086-.017.15S1539.849,593.861,1539.888,593.843Z",
  transform: "translate(-1513.125 -585.976)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_530",
  "data-name": "Path 530",
  d: "M1626.2,573.745a.061.061,0,0,1-.023,0,.063.063,0,0,1-.021-.011.056.056,0,0,1-.014-.018.055.055,0,0,1-.007-.022.05.05,0,0,1,0-.023.053.053,0,0,1,.011-.02.059.059,0,0,1,.04-.022l.2-.045a.059.059,0,0,1,.023,0,.066.066,0,0,1,.022.008.064.064,0,0,1,.017.016.06.06,0,0,1,.009.021.063.063,0,0,1,0,.023.056.056,0,0,1-.009.022.053.053,0,0,1-.016.016.06.06,0,0,1-.022.009l-.205.045-.012,0Z",
  transform: "translate(-1597.681 -566.377)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_531",
  "data-name": "Path 531",
  d: "M1636.22,565.882a.06.06,0,0,1-.038-.014.059.059,0,0,1-.02-.035l-.051-.314a.071.071,0,0,1,0-.023.066.066,0,0,1,.01-.021.061.061,0,0,1,.017-.016.063.063,0,0,1,.022-.008.062.062,0,0,1,.023,0,.063.063,0,0,1,.021.01.067.067,0,0,1,.016.017.058.058,0,0,1,.008.022l.051.314a.061.061,0,0,1-.01.044.058.058,0,0,1-.038.024Z",
  transform: "translate(-1607.447 -558.418)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_532",
  "data-name": "Path 532",
  d: "M1505.936,499.556s-.414.753-.667.789-.785-1.463.562-1.521c0,0,.093-.51.954-.128a1.456,1.456,0,0,1,.9,1.171.4.4,0,0,0-.346.422c.02.31-.243-.1-.589-.2S1506.1,500.207,1505.936,499.556Z",
  transform: "translate(-1479.069 -492.942)",
  fill: "#fdbc12"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_533",
  "data-name": "Path 533",
  d: "M1504.558,497.758c-.055,0-.118-.048-.206-.113a1.208,1.208,0,0,0-.358-.208,1.038,1.038,0,0,0-.253-.033.519.519,0,0,1-.567-.406c-.133.223-.424.669-.641.7-.045.006-.114-.009-.2-.118a1.143,1.143,0,0,1-.108-1.056.873.873,0,0,1,.811-.462.405.405,0,0,1,.191-.215.981.981,0,0,1,.83.09,1.508,1.508,0,0,1,.939,1.221.059.059,0,0,1-.013.041.058.058,0,0,1-.037.021.344.344,0,0,0-.3.36c0,.061,0,.135-.055.165a.088.088,0,0,1-.042.011Zm-1.368-.964h.007a.057.057,0,0,1,.032.014.059.059,0,0,1,.018.03c.112.432.275.44.5.45a1.144,1.144,0,0,1,.281.039,1.287,1.287,0,0,1,.4.226,1.316,1.316,0,0,0,.118.081.235.235,0,0,0,0-.043.444.444,0,0,1,.341-.471,1.409,1.409,0,0,0-.863-1.071c-.4-.18-.617-.151-.725-.094a.275.275,0,0,0-.092.074.272.272,0,0,0-.053.106.061.061,0,0,1-.02.033.059.059,0,0,1-.036.014.792.792,0,0,0-.752.4,1.027,1.027,0,0,0,.1.936c.042.057.073.073.082.071.163-.024.469-.478.623-.759a.06.06,0,0,1,.02-.023.062.062,0,0,1,.029-.01Z",
  transform: "translate(-1476.323 -490.237)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_534",
  "data-name": "Path 534",
  d: "M1560.194,515.163a.039.039,0,0,1-.017,0,.036.036,0,0,1-.013-.01.986.986,0,0,0-.785-.338l-.015,0a.043.043,0,0,1-.013-.008.044.044,0,0,1-.009-.012.045.045,0,0,1,0-.015.038.038,0,0,1,.01-.028.045.045,0,0,1,.012-.009l.015,0a1.067,1.067,0,0,1,.849.366.037.037,0,0,1,.007.013.035.035,0,0,1,0,.015.037.037,0,0,1,0,.015.035.035,0,0,1-.009.012A.04.04,0,0,1,1560.194,515.163Z",
  transform: "translate(-1532.303 -508.776)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_535",
  "data-name": "Path 535",
  d: "M1590.279,539.315a.039.039,0,0,1-.024-.007.037.037,0,0,1-.015-.021.266.266,0,0,0-.075-.118.262.262,0,0,0-.125-.063.039.039,0,0,1-.014-.006.038.038,0,0,1-.011-.011.04.04,0,0,1-.007-.03.039.039,0,0,1,.006-.014.035.035,0,0,1,.011-.011.042.042,0,0,1,.014-.006.039.039,0,0,1,.016,0,.338.338,0,0,1,.261.238.046.046,0,0,1,0,.015.044.044,0,0,1,0,.015.043.043,0,0,1-.01.012.037.037,0,0,1-.014.007l-.009,0Z",
  transform: "translate(-1562.322 -532.555)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_536",
  "data-name": "Path 536",
  d: "M1531.6,580.78a.053.053,0,0,1-.019,0,1.325,1.325,0,0,0-.455-.069.058.058,0,0,1-.062-.055.058.058,0,0,1,.015-.043.059.059,0,0,1,.041-.02,1.441,1.441,0,0,1,.5.076.058.058,0,0,1,.031.025.059.059,0,0,1-.051.089Z",
  transform: "translate(-1504.631 -573.237)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_537",
  "data-name": "Path 537",
  d: "M1639.643,605.307h0l-.005,0,0,0a.01.01,0,0,1,0-.005.013.013,0,0,1,0-.006l.017-.1,0-.005,0,0,.005,0h.006l.005,0,0,0a.015.015,0,0,1,0,.011l-.018.1a.014.014,0,0,1-.015.012Z",
  transform: "translate(-1610.89 -597.307)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_538",
  "data-name": "Path 538",
  d: "M1637.458,613.411l-.007,0a.015.015,0,0,1-.007-.009.017.017,0,0,1,0-.011,1.125,1.125,0,0,0,.135-.377.012.012,0,0,1,0-.005l0,0,.005,0h.006l.005,0,0,0a.01.01,0,0,1,0,.005.011.011,0,0,1,0,.006,1.158,1.158,0,0,1-.139.387l-.005.005-.008,0Z",
  transform: "translate(-1608.752 -604.96)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_539",
  "data-name": "Path 539",
  d: "M1648.261,621.795h0l-.005,0,0,0a.018.018,0,0,1,0-.006.015.015,0,0,1,0-.006l.029-.1a.011.011,0,0,1,0-.005l0,0,.005,0h.006a.017.017,0,0,1,.009.007.018.018,0,0,1,0,.011l-.029.1a.016.016,0,0,1-.014.01Z",
  transform: "translate(-1619.325 -613.438)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_540",
  "data-name": "Path 540",
  d: "M2292.049,2403.99a.081.081,0,0,1,.023.118c-.02.025-.1.016-.122-.006a.093.093,0,0,1-.019-.034.092.092,0,0,1,0-.038.094.094,0,0,1,.012-.037.108.108,0,0,1,.026-.029C2292.011,2403.921,2292.025,2403.969,2292.049,2403.99Z",
  transform: "translate(-2249.351 -2357.912)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_541",
  "data-name": "Path 541",
  d: "M2310.632,2242.99c-.012-.026-.066-.039-.025-.085a.107.107,0,0,1,.127-.024c.028.024.02.084-.017.125S2310.657,2243.02,2310.632,2242.99Z",
  transform: "translate(-2267.62 -2200.251)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_542",
  "data-name": "Path 542",
  d: "M2321.428,1790.383c.03-.036.057-.051.1,0s0,.061-.024.086-.06.053-.1,0S2321.4,1790.41,2321.428,1790.383Z",
  transform: "translate(-2278.183 -1757.333)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_543",
  "data-name": "Path 543",
  d: "M2026.142,1710.75c-.016-.018-.04-.034-.028-.059s.049-.023.079-.024a.076.076,0,0,1,.041.015.075.075,0,0,1,.026.036.237.237,0,0,1,0,.085.475.475,0,0,1-.085-.014C2026.164,1710.785,2026.154,1710.765,2026.142,1710.75Z",
  transform: "translate(-1989.174 -1679.339)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_544",
  "data-name": "Path 544",
  d: "M1552.6,2393.175c-.016-.017-.039-.034-.028-.059s.049-.024.078-.024a.074.074,0,0,1,.041.015.078.078,0,0,1,.025.036.239.239,0,0,1,0,.086.508.508,0,0,1-.085-.014C1552.62,2393.21,1552.611,2393.19,1552.6,2393.175Z",
  transform: "translate(-1525.677 -2347.286)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_545",
  "data-name": "Path 545",
  d: "M1994.231,1650.748c-.034.021-.046,0-.063-.018a.077.077,0,0,1-.018-.022.081.081,0,0,1-.009-.028.078.078,0,0,1,.017-.054.069.069,0,0,1,.042,0,.071.071,0,0,1,.037.02.108.108,0,0,1,.012.055.1.1,0,0,1-.018.053Z",
  transform: "translate(-1957.882 -1620.566)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_546",
  "data-name": "Path 546",
  d: "M1419.913,2110.355c-.016-.016-.037-.032-.017-.058a.091.091,0,0,1,.113,0c.027.027.008.039-.01.059S1419.944,2110.4,1419.913,2110.355Z",
  transform: "translate(-1395.812 -2070.473)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_547",
  "data-name": "Path 547",
  d: "M2116.2,1614.832c.019-.019.036-.012.039,0,.01.033.082-.015.066.052-.007.029,0,.061-.04.066s-.036-.027-.053-.041S2116.213,1614.859,2116.2,1614.832Z",
  transform: "translate(-2077.351 -1585.527)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_548",
  "data-name": "Path 548",
  d: "M2127.052,1964.518c-.016-.016-.037-.033-.017-.059a.093.093,0,0,1,.112,0c.026.024.007.041-.01.059S2127.081,1964.567,2127.052,1964.518Z",
  transform: "translate(-2087.949 -1927.728)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_549",
  "data-name": "Path 549",
  d: "M2116.286,1695.111c-.027.025-.044.009-.059-.01s-.052-.039-.016-.072a.069.069,0,0,1,.04-.017.07.07,0,0,1,.042.01.071.071,0,0,1,.013.046A.068.068,0,0,1,2116.286,1695.111Z",
  transform: "translate(-2077.347 -1664.017)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_550",
  "data-name": "Path 550",
  d: "M2268.847,2448.823c-.027.026-.045.009-.06-.01s-.051-.039-.016-.071a.063.063,0,0,1,.019-.016.058.058,0,0,1,.024-.006.068.068,0,0,1,.024,0,.054.054,0,0,1,.02.013.062.062,0,0,1,.012.021.054.054,0,0,1,0,.024.056.056,0,0,1-.008.023.063.063,0,0,1-.016.017Z",
  transform: "translate(-2226.671 -2401.734)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_551",
  "data-name": "Path 551",
  d: "M2271.447,2243.893c-.026.025-.044.009-.06-.01s-.052-.039-.016-.072a.054.054,0,0,1,.019-.016.063.063,0,0,1,.023-.006.056.056,0,0,1,.024,0,.058.058,0,0,1,.02.014.057.057,0,0,1,.012.021.056.056,0,0,1-.006.047.06.06,0,0,1-.017.018Z",
  transform: "translate(-2229.216 -2201.152)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_552",
  "data-name": "Path 552",
  d: "M2237.679,1906.675c.012-.008.029-.039.049-.015a.083.083,0,0,1,.006.035.079.079,0,0,1-.009.035.129.129,0,0,1-.052.049.034.034,0,0,1-.013,0l-.013,0-.011-.008a.059.059,0,0,1-.008-.011c0-.009-.01-.027-.005-.032a.641.641,0,0,1,.056-.053Z",
  transform: "translate(-2196.197 -1871.166)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_553",
  "data-name": "Path 553",
  d: "M2319.93,1760.841a.214.214,0,0,1,.017-.082c.024-.036.048-.013.069.011s.036.033.015.06A.133.133,0,0,1,2319.93,1760.841Z",
  transform: "translate(-2276.76 -1728.351)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_554",
  "data-name": "Path 554",
  d: "M2163.294,2177.5c-.022-.02-.039-.047,0-.067a.156.156,0,0,1,.085-.005c.011,0-.009.086-.023.1S2163.322,2177.535,2163.294,2177.5Z",
  transform: "translate(-2123.423 -2136.198)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_555",
  "data-name": "Path 555",
  d: "M1581.94,2295.847c-.024,0-.06.006-.069-.006a.076.076,0,0,1-.012-.047.071.071,0,0,1,.02-.044.03.03,0,0,1,.009-.009l.012,0,.013,0a.025.025,0,0,1,.011.007C1581.96,2295.775,1581.935,2295.814,1581.94,2295.847Z",
  transform: "translate(-1554.347 -2251.998)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_556",
  "data-name": "Path 556",
  d: "M2213.64,2016.891c.013-.019-.015-.055.019-.058.018,0,.066-.027.062.028,0,.016.02.055-.024.048C2213.679,2016.907,2213.647,2016.928,2213.64,2016.891Z",
  transform: "translate(-2172.724 -1979.004)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_557",
  "data-name": "Path 557",
  d: "M2145.846,2034.865c.021-.01.039-.013.05.007a.069.069,0,0,1,.015.045.068.068,0,0,1-.02.044c-.019.014-.034-.025-.051-.039S2145.834,2034.88,2145.846,2034.865Z",
  transform: "translate(-2106.35 -1996.652)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_558",
  "data-name": "Path 558",
  d: "M1582.018,2385.594a.236.236,0,0,1-.029-.048c0-.008.007-.021.014-.03a.034.034,0,0,1,.009-.009.032.032,0,0,1,.012,0,.03.03,0,0,1,.013,0,.029.029,0,0,1,.011.007c.034.028.013.065.014.1Z",
  transform: "translate(-1554.473 -2339.86)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_559",
  "data-name": "Path 559",
  d: "M2045.061,1683.058c-.033-.008-.073.013-.1-.025a.084.084,0,0,1-.006-.033c.033.007.073-.011.1.025a.08.08,0,0,1,.006.033Z",
  transform: "translate(-2007.622 -1652.26)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_560",
  "data-name": "Path 560",
  d: "M2224.091,2243a.032.032,0,0,1-.006-.025.038.038,0,0,1,.013-.022c.026-.023.044-.011.059.01a.032.032,0,0,1,.006.011.03.03,0,0,1,0,.013.038.038,0,0,1,0,.012.032.032,0,0,1-.01.01C2224.123,2243.031,2224.107,2243.017,2224.091,2243Z",
  transform: "translate(-2182.947 -2200.321)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_561",
  "data-name": "Path 561",
  d: "M2266.869,2360.2a.038.038,0,0,1-.006-.025.034.034,0,0,1,.013-.022c.025-.023.044-.011.058.01a.028.028,0,0,1,.006.012.039.039,0,0,1,0,.013.023.023,0,0,1,0,.012.034.034,0,0,1-.009.009C2266.9,2360.228,2266.886,2360.213,2266.869,2360.2Z",
  transform: "translate(-2224.818 -2315.031)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_562",
  "data-name": "Path 562",
  d: "M2183.415,1850.551c-.013-.012-.021-.027,0-.039s.021.007.029.013.022.027,0,.039S2183.425,1850.555,2183.415,1850.551Z",
  transform: "translate(-2143.127 -1816.217)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_563",
  "data-name": "Path 563",
  d: "M2166.22,1846.089c-.005-.024.015-.032.028-.042h.013a.032.032,0,0,1,.011.007c.008.023-.014.031-.027.039S2166.229,1846.091,2166.22,1846.089Z",
  transform: "translate(-2126.31 -1811.847)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_564",
  "data-name": "Path 564",
  d: "M2039.664,1821.261c.012-.013.027-.021.039,0s-.007.02-.013.029-.027.022-.039,0S2039.659,1821.27,2039.664,1821.261Z",
  transform: "translate(-2002.426 -1787.575)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_565",
  "data-name": "Path 565",
  d: "M2138.551,2035.711a.23.23,0,0,1-.044-.029c-.007-.007,0-.021-.007-.032a.19.19,0,0,1,.044.022C2138.551,2035.679,2138.549,2035.694,2138.551,2035.711Z",
  transform: "translate(-2099.179 -1997.429)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_566",
  "data-name": "Path 566",
  d: "M2105.987,1702.255c-.006-.024.015-.032.028-.042s.023,0,.025.008c.008.022-.014.03-.027.039S2105.994,1702.257,2105.987,1702.255Z",
  transform: "translate(-2067.355 -1671.064)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_567",
  "data-name": "Path 567",
  d: "M2410.586,2395.531c-.005-.024.015-.032.028-.042a.027.027,0,0,1,.025.008c.007.022-.014.03-.027.039S2410.594,2395.533,2410.586,2395.531Z",
  transform: "translate(-2365.491 -2349.633)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_568",
  "data-name": "Path 568",
  d: "M2224.66,2326.037c-.006-.024.015-.032.029-.042s.022,0,.024.008c.008.022-.013.031-.027.039S2224.668,2326.04,2224.66,2326.037Z",
  transform: "translate(-2183.51 -2281.613)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_569",
  "data-name": "Path 569",
  d: "M2206.732,2070.662c-.005-.025.015-.032.028-.042a.029.029,0,0,1,.014,0,.033.033,0,0,1,.011.007c.007.022-.014.03-.027.039S2206.74,2070.665,2206.732,2070.662Z",
  transform: "translate(-2165.963 -2031.656)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_570",
  "data-name": "Path 570",
  d: "M2009.786,1901.627l-.007-.027h.017a.121.121,0,0,1,.008.026Z",
  transform: "translate(-1973.189 -1866.222)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_571",
  "data-name": "Path 571",
  d: "M2154.28,1787.049v-.019a.111.111,0,0,1,.025.011s0,.011,0,.017Z",
  transform: "translate(-2114.624 -1754.083)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_572",
  "data-name": "Path 572",
  d: "M2052.889,1881.49v-.016a.049.049,0,0,1,.028,0c.016.006.015.017,0,.022a.073.073,0,0,1-.028,0Z",
  transform: "translate(-2015.384 -1846.52)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_573",
  "data-name": "Path 573",
  d: "M2054.792,1881.55c.009,0,.024,0,.026.005s0,.023-.011.02a.143.143,0,0,1-.027-.014Z",
  transform: "translate(-2017.234 -1846.597)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_574",
  "data-name": "Path 574",
  d: "M1606.2,2019.1c.032.032.045.061-.007.1s-.06-.007-.082-.031-.048-.063,0-.1S1606.176,2019.074,1606.2,2019.1Z",
  transform: "translate(-1578.055 -1981.184)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_575",
  "data-name": "Path 575",
  d: "M667.125,2154.655c.018-.014.039-.038.061-.023s.018.051.017.079a.071.071,0,0,1-.018.039.069.069,0,0,1-.037.022.215.215,0,0,1-.085,0,.465.465,0,0,1,.021-.083C667.091,2154.673,667.111,2154.665,667.125,2154.655Z",
  transform: "translate(-658.958 -2113.882)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_576",
  "data-name": "Path 576",
  d: "M1700.31,1936.751c-.018-.035.006-.045.023-.06a.072.072,0,0,1,.024-.016.072.072,0,0,1,.056,0,.076.076,0,0,1,.024.016.071.071,0,0,1-.022.079.1.1,0,0,1-.055.006A.1.1,0,0,1,1700.31,1936.751Z",
  transform: "translate(-1670.278 -1900.548)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_577",
  "data-name": "Path 577",
  d: "M659.479,2200.494c.016.02.009.037-.008.039-.034.008.008.082-.058.06-.027-.009-.06-.008-.062-.046s.029-.033.045-.049S659.451,2200.5,659.479,2200.494Z",
  transform: "translate(-651.41 -2158.77)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_578",
  "data-name": "Path 578",
  d: "M1647.043,2053.213c-.023-.028-.005-.045.015-.058s.042-.047.073-.01a.058.058,0,0,1,.013.02.064.064,0,0,1,0,.023.058.058,0,0,1-.007.023.056.056,0,0,1-.015.018.052.052,0,0,1-.021.01.052.052,0,0,1-.024,0,.054.054,0,0,1-.021-.009.051.051,0,0,1-.016-.017Z",
  transform: "translate(-1618.137 -2014.536)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_579",
  "data-name": "Path 579",
  d: "M1476.17,2089.107c0-.033.023-.04.039-.056a.035.035,0,0,1,.059,0,.032.032,0,0,1-.016.055.282.282,0,0,1-.082,0Z",
  transform: "translate(-1450.9 -2049.682)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_580",
  "data-name": "Path 580",
  d: "M1461.472,1926.013a.023.023,0,0,1-.007-.023.023.023,0,0,1,.007-.011.024.024,0,0,1,.011-.006c.022-.009.039-.055.066-.021a.065.065,0,0,1,0,.034.062.062,0,0,1-.013.031C1461.526,1926.03,1461.5,1926.016,1461.472,1926.013Z",
  transform: "translate(-1436.506 -1890.046)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_581",
  "data-name": "Path 581",
  d: "M1667.46,1984.216c.011-.031-.006-.073.033-.093a.093.093,0,0,1,.033,0c-.01.032.005.072-.033.093a.084.084,0,0,1-.033,0Z",
  transform: "translate(-1638.131 -1946.991)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_582",
  "data-name": "Path 582",
  d: "M1598.992,1944.84a.036.036,0,0,1,.026,0,.033.033,0,0,1,.021.015c.021.028.007.044-.015.057a.03.03,0,0,1-.012.005H1599a.032.032,0,0,1-.012-.006.033.033,0,0,1-.008-.01C1598.958,1944.87,1598.973,1944.855,1598.992,1944.84Z",
  transform: "translate(-1571.093 -1908.54)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_583",
  "data-name": "Path 583",
  d: "M1492.8,2185.06c.022,0,.057,0,.065.013a.069.069,0,0,1-.008.066c-.036.021-.039-.025-.058-.04S1492.778,2185.072,1492.8,2185.06Z",
  transform: "translate(-1467.159 -2143.669)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_584",
  "data-name": "Path 584",
  d: "M1523.251,2071.784c.019-.013.039-.027.058,0a.12.12,0,0,1,.01.031h-.078Z",
  transform: "translate(-1496.971 -2032.781)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_585",
  "data-name": "Path 585",
  d: "M1446.194,1969.03h.03a.2.2,0,0,1-.026.041c-.007.006-.021,0-.033,0a.042.042,0,0,1,.007-.027A.045.045,0,0,1,1446.194,1969.03Z",
  transform: "translate(-1421.532 -1932.222)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_586",
  "data-name": "Path 586",
  d: "M1643.824,2042.437c.025,0,.03.018.039.031a.033.033,0,0,1,0,.013.03.03,0,0,1-.008.01c-.022.005-.029-.016-.039-.03S1643.822,2042.444,1643.824,2042.437Z",
  transform: "translate(-1614.987 -2004.071)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_587",
  "data-name": "Path 587",
  d: "M1017.837,2263.42l.026,0c0,.006,0,.015-.007.015a.083.083,0,0,1-.027,0Z",
  transform: "translate(-1002.283 -2220.366)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_588",
  "data-name": "Path 588",
  d: "M1691.911,1577.16l.018,0a.09.09,0,0,1-.012.024s-.011,0-.017,0Z",
  transform: "translate(-1662.053 -1548.666)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_589",
  "data-name": "Path 589",
  d: "M1502.708,1953.572l0,.027c-.005,0-.015,0-.016,0a.09.09,0,0,1-.006-.027Z",
  transform: "translate(-1476.857 -1917.09)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_590",
  "data-name": "Path 590",
  d: "M1405.63,2207.678l0-.019a.138.138,0,0,1,.024.013s0,.011,0,.016Z",
  transform: "translate(-1381.856 -2165.789)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_591",
  "data-name": "Path 591",
  d: "M1514.651,2090.26l.019,0a.108.108,0,0,1-.013.024s-.011,0-.017,0Z",
  transform: "translate(-1488.553 -2050.88)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_592",
  "data-name": "Path 592",
  d: "M768.81,2083.658c-.017-.016-.037-.032-.018-.058a.092.092,0,0,1,.113,0c.027.023.008.039-.009.059S768.841,2083.707,768.81,2083.658Z",
  transform: "translate(-758.522 -2044.342)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_593",
  "data-name": "Path 593",
  d: "M822.527,2043.255c0-.032.023-.042.039-.056s.039-.024.059,0a.032.032,0,0,1,.009.015.034.034,0,0,1,0,.018.033.033,0,0,1-.009.015.037.037,0,0,1-.016.008.292.292,0,0,1-.083,0Z",
  transform: "translate(-811.123 -2004.803)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_594",
  "data-name": "Path 594",
  d: "M841.691,2158.34c.022,0,.056,0,.064.014a.067.067,0,0,1,0,.033.069.069,0,0,1-.013.032c-.036.021-.039-.024-.059-.04S841.671,2158.352,841.691,2158.34Z",
  transform: "translate(-829.865 -2117.516)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_595",
  "data-name": "Path 595",
  d: "M872.158,2045.061c.02-.014.039-.028.058,0a.131.131,0,0,1,.01.031h-.078Z",
  transform: "translate(-859.691 -2006.624)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_596",
  "data-name": "Path 596",
  d: "M724.4,2184.384l.027,0c0,.006,0,.015,0,.016a.11.11,0,0,1-.027.006Z",
  transform: "translate(-715.074 -2143.003)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_597",
  "data-name": "Path 597",
  d: "M754.543,2180.958l0-.018a.125.125,0,0,1,.024.012s0,.011,0,.017Z",
  transform: "translate(-744.582 -2139.636)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_598",
  "data-name": "Path 598",
  d: "M863.558,2063.52l.019,0a.115.115,0,0,1-.013.024s-.011,0-.016,0Z",
  transform: "translate(-851.273 -2024.707)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_599",
  "data-name": "Path 599",
  d: "M976.311,2275.2c.006,0,0,.03,0,.056,0,.008-.005.02-.011.022s-.141-.052-.139-.073,0-.053.022-.073.039,0,.06,0S976.275,2275.168,976.311,2275.2Z",
  transform: "translate(-961.494 -2231.825)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_600",
  "data-name": "Path 600",
  d: "M827.247,2209.76a.072.072,0,0,1-.012-.027.069.069,0,0,1,0-.029.071.071,0,0,1,.012-.027.074.074,0,0,1,.021-.02c.024-.014.088.021.094.045a.077.077,0,0,1,0,.033.079.079,0,0,1-.009.032.087.087,0,0,1-.022.026.089.089,0,0,1-.03.014C827.255,2209.827,827.259,2209.786,827.247,2209.76Z",
  transform: "translate(-815.73 -2167.742)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_601",
  "data-name": "Path 601",
  d: "M1692.666,1926.96c-.029.027-.054.039-.084-.009s.008-.052.03-.071.056-.039.086.008S1692.69,1926.941,1692.666,1926.96Z",
  transform: "translate(-1662.709 -1890.943)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_602",
  "data-name": "Path 602",
  d: "M976.134,2140.5c.006.018.021.039,0,.056s-.047,0-.071-.008a.059.059,0,0,1-.029-.024.064.064,0,0,1-.01-.036.208.208,0,0,1,.024-.07.365.365,0,0,1,.063.039C976.127,2140.466,976.128,2140.486,976.134,2140.5Z",
  transform: "translate(-961.368 -2099.976)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_603",
  "data-name": "Path 603",
  d: "M684.2,2142.878c.011.016.031.033.018.054s-.045.015-.07.012a.06.06,0,0,1-.034-.017.063.063,0,0,1-.018-.033.193.193,0,0,1,0-.073.408.408,0,0,1,.072.021C684.19,2142.847,684.2,2142.865,684.2,2142.878Z",
  transform: "translate(-675.633 -2102.325)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_604",
  "data-name": "Path 604",
  d: "M781.374,2015.9c.011.017.031.033.018.054s-.045.015-.07.012a.061.061,0,0,1-.051-.05.2.2,0,0,1,0-.074.374.374,0,0,1,.072.021C781.359,2015.867,781.365,2015.884,781.374,2015.9Z",
  transform: "translate(-770.74 -1978.038)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_605",
  "data-name": "Path 605",
  d: "M876.571,2203.2l-.01.006h-.012l-.01-.006a.022.022,0,0,1-.007-.01.118.118,0,0,1,0-.042c.044,0,.035-.063.078-.063.015,0,.032-.011.043-.005s0,.025-.005.035C876.631,2203.149,876.625,2203.194,876.571,2203.2Z",
  transform: "translate(-863.981 -2161.302)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_606",
  "data-name": "Path 606",
  d: "M1035.365,2235.449a.062.062,0,0,1,.048,0,.063.063,0,0,1,.038.03.094.094,0,0,1,0,.037.088.088,0,0,1-.011.035c-.009.017-.082-.024-.1-.056C1035.341,2235.475,1035.341,2235.46,1035.365,2235.449Z",
  transform: "translate(-1019.425 -2192.981)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_607",
  "data-name": "Path 607",
  d: "M1033.849,2253.342c.008.018.018.04-.005.053a.085.085,0,0,1-.051,0,.083.083,0,0,1-.039-.033c-.013-.028.007-.035.027-.043S1033.841,2253.295,1033.849,2253.342Z",
  transform: "translate(-1017.864 -2210.466)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_608",
  "data-name": "Path 608",
  d: "M2077.929,1599.4c.012.015.027.032.008.052a.08.08,0,0,1-.05.011.078.078,0,0,1-.046-.021c-.02-.023,0-.036.014-.05S2077.908,1599.352,2077.929,1599.4Z",
  transform: "translate(-2039.798 -1570.403)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_609",
  "data-name": "Path 609",
  d: "M1663.583,1961.446c.026-.019.039,0,.05.015s.039.039.006.063a.052.052,0,0,1-.018.01.047.047,0,0,1-.02,0,.055.055,0,0,1-.02-.006.049.049,0,0,1-.015-.014.05.05,0,0,1-.008-.019.04.04,0,0,1,0-.021.041.041,0,0,1,.009-.018.046.046,0,0,1,.016-.013Z",
  transform: "translate(-1634.311 -1924.79)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_610",
  "data-name": "Path 610",
  d: "M2089.683,1874.028c.013.018.025.036,0,.052a.06.06,0,0,1-.041.01.058.058,0,0,1-.037-.02.059.059,0,0,1,0-.037.058.058,0,0,1,.021-.03C2089.66,1873.981,2089.668,1874.012,2089.683,1874.028Z",
  transform: "translate(-2051.317 -1839.204)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_611",
  "data-name": "Path 611",
  d: "M1050.937,2228.379c.018.009.049.015.052.028a.06.06,0,0,1-.006.041.058.058,0,0,1-.03.028l-.011,0h-.011a.026.026,0,0,1-.01-.006.023.023,0,0,1-.006-.01C1050.9,2228.431,1050.931,2228.409,1050.937,2228.379Z",
  transform: "translate(-1034.662 -2186.069)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_612",
  "data-name": "Path 612",
  d: "M2337.4,2286.58c.028,0,.036.022.047.037s.02.034,0,.051a.028.028,0,0,1-.047-.015.251.251,0,0,1,0-.073Z",
  transform: "translate(-2293.852 -2243.035)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_613",
  "data-name": "Path 613",
  d: "M1016.822,2120.378a.208.208,0,0,1,.008.048c0,.007-.013.014-.021.019l-.01,0h-.011a.027.027,0,0,1-.01-.006.031.031,0,0,1-.006-.01c-.018-.033.011-.057.021-.084Z",
  transform: "translate(-1001.242 -2080.331)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_614",
  "data-name": "Path 614",
  d: "M905.141,2237.837a.025.025,0,0,1,0,.01.02.02,0,0,1,0,.01.018.018,0,0,1-.008.007l-.01,0c-.021,0-.046.036-.06,0a.06.06,0,0,1,.006-.029.059.059,0,0,1,.019-.022C905.1,2237.809,905.123,2237.829,905.141,2237.837Z",
  transform: "translate(-891.907 -2195.303)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_615",
  "data-name": "Path 615",
  d: "M1723.664,1981.27c.027.011.064,0,.078.032a.069.069,0,0,1,0,.028c-.027-.009-.063,0-.078-.031a.077.077,0,0,1,0-.029Z",
  transform: "translate(-1693.142 -1944.202)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_616",
  "data-name": "Path 616",
  d: "M1760.745,1922.98a.03.03,0,0,1,0,.022.032.032,0,0,1-.013.017c-.025.017-.039,0-.05-.015a.029.029,0,0,1,0-.011.03.03,0,0,1,0-.011.027.027,0,0,1,.005-.01.024.024,0,0,1,.009-.007C1760.72,1922.949,1760.733,1922.962,1760.745,1922.98Z",
  transform: "translate(-1729.374 -1887.127)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_617",
  "data-name": "Path 617",
  d: "M1163.257,2107.17c.017.021.009.037-.008.039-.034.008.008.083-.057.061-.028-.009-.06-.009-.062-.046s.029-.033.045-.048S1163.231,2107.181,1163.257,2107.17Z",
  transform: "translate(-1144.5 -2067.426)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_618",
  "data-name": "Path 618",
  d: "M1141.311,2184.088c.011.017.031.034.018.054s-.045.014-.07.012a.063.063,0,0,1-.051-.05.2.2,0,0,1,0-.073.381.381,0,0,1,.072.021C1141.3,2184.057,1141.3,2184.077,1141.311,2184.088Z",
  transform: "translate(-1123.042 -2142.66)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_619",
  "data-name": "Path 619",
  d: "M1148.507,2214.251c.031-.014.039.006.051.022a.064.064,0,0,1,.014.021.063.063,0,0,1,0,.024.068.068,0,0,1-.005.025.059.059,0,0,1-.015.02.056.056,0,0,1-.037,0,.059.059,0,0,1-.03-.021.085.085,0,0,1,.018-.091Z",
  transform: "translate(-1130.165 -2172.236)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_620",
  "data-name": "Path 620",
  d: "M1113.634,2150.42c.027.01.064,0,.079.032a.076.076,0,0,1,0,.029c-.028-.009-.063,0-.079-.031A.084.084,0,0,1,1113.634,2150.42Z",
  transform: "translate(-1096.053 -2109.764)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_621",
  "data-name": "Path 621",
  d: "M1150.728,2092.123a.034.034,0,0,1,0,.011.028.028,0,0,1,0,.011.03.03,0,0,1,0,.01l-.009.007c-.024.017-.039,0-.049-.014a.029.029,0,0,1,0-.011.028.028,0,0,1,0-.011.026.026,0,0,1,.005-.01l.009-.007C1150.7,2092.093,1150.716,2092.106,1150.728,2092.123Z",
  transform: "translate(-1132.298 -2052.682)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_622",
  "data-name": "Path 622",
  d: "M1433.476,1810.17c0,.019,0,.049-.013.056a.053.053,0,0,1-.03,0,.058.058,0,0,1-.027-.012c-.018-.032.022-.034.037-.05S1433.468,1810.154,1433.476,1810.17Z",
  transform: "translate(-1409.039 -1776.719)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_623",
  "data-name": "Path 623",
  d: "M714.216,1999.242a.029.029,0,0,1,0,.022.028.028,0,0,1-.013.017c-.024.017-.039,0-.049-.014a.028.028,0,0,1,0-.01.027.027,0,0,1,0-.011.028.028,0,0,1,.005-.01.028.028,0,0,1,.009-.007C714.191,1999.212,714.2,1999.225,714.216,1999.242Z",
  transform: "translate(-705.047 -1961.772)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_624",
  "data-name": "Path 624",
  d: "M982.773,2194.98c-.024.019-.039.006-.05-.013a.024.024,0,0,1,0-.011.029.029,0,0,1,.006-.022.024.024,0,0,1,.009-.007c.024-.017.039,0,.049.014a.023.023,0,0,1,.005.01.024.024,0,0,1,0,.011.024.024,0,0,1-.005.01.018.018,0,0,1-.009.006Z",
  transform: "translate(-967.917 -2153.319)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_625",
  "data-name": "Path 625",
  d: "M2182.073,1849c-.018.015-.035.021-.04,0s.026-.028.04-.042.03-.016.033,0S2182.078,1848.988,2182.073,1849Z",
  transform: "translate(-2141.788 -1814.69)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_626",
  "data-name": "Path 626",
  d: "M1470.43,1843.591c.011.018.023.035,0,.05a.1.1,0,0,1-.027.008l0-.069Z",
  transform: "translate(-1445.252 -1809.433)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_627",
  "data-name": "Path 627",
  d: "M2159.287,1794.078c-.011.01-.025.015-.033,0s.008-.017.014-.024.025-.015.033,0S2159.293,1794.07,2159.287,1794.078Z",
  transform: "translate(-2119.492 -1760.95)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_628",
  "data-name": "Path 628",
  d: "M2245.132,1806.5l.006.039c-.009,0-.022,0-.026-.011a.221.221,0,0,1-.011-.041Z",
  transform: "translate(-2203.517 -1773.13)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_629",
  "data-name": "Path 629",
  d: "M1587.979,1882.926v.026a.16.16,0,0,1-.035-.024c0-.005,0-.019,0-.028a.039.039,0,0,1,.021.008A.038.038,0,0,1,1587.979,1882.926Z",
  transform: "translate(-1560.301 -1847.919)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_630",
  "data-name": "Path 630",
  d: "M1816.1,1741.838c0,.022-.016.026-.029.033s-.02-.005-.02-.01.015-.024.028-.032S1816.1,1741.836,1816.1,1741.838Z",
  transform: "translate(-1783.573 -1709.842)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_631",
  "data-name": "Path 631",
  d: "M1675.361,1959.082c0,.022-.016.026-.028.033a.025.025,0,0,1-.021-.01c0-.02.015-.025.028-.032S1675.354,1959.078,1675.361,1959.082Z",
  transform: "translate(-1645.816 -1922.476)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_632",
  "data-name": "Path 632",
  d: "M956.646,2227.108c.022-.008.046-.026.065-.006s0,.054-.006.082a.074.074,0,0,1-.028.033.072.072,0,0,1-.042.011.241.241,0,0,1-.081-.025.473.473,0,0,1,.043-.075C956.607,2227.117,956.63,2227.115,956.646,2227.108Z",
  transform: "translate(-942.308 -2184.81)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_633",
  "data-name": "Path 633",
  d: "M1837.083,1750.234c-.022-.028-.005-.044.016-.058s.042-.048.072-.01a.059.059,0,0,1,.014.019.064.064,0,0,1,0,.024.059.059,0,0,1-.006.023.055.055,0,0,1-.016.019.056.056,0,0,1-.022.01.055.055,0,0,1-.024,0,.055.055,0,0,1-.022-.01.053.053,0,0,1-.016-.018Z",
  transform: "translate(-1804.145 -1717.985)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_634",
  "data-name": "Path 634",
  d: "M1833.869,1739.461c.024,0,.03.017.039.031s-.005.022-.01.024c-.022.005-.029-.017-.039-.031S1833.865,1739.469,1833.869,1739.461Z",
  transform: "translate(-1801 -1707.523)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_635",
  "data-name": "Path 635",
  d: "M1483.512,2446.773c.031-.015.039.006.051.022a.06.06,0,0,1,.014.021.066.066,0,0,1,0,.024.07.07,0,0,1-.005.024.062.062,0,0,1-.015.021.059.059,0,0,1-.037,0,.063.063,0,0,1-.03-.021.084.084,0,0,1,0-.048.082.082,0,0,1,.022-.043Z",
  transform: "translate(-1458.063 -2399.825)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_636",
  "data-name": "Path 636",
  d: "M1443.565,2416.72c.027.01.064,0,.079.032a.092.092,0,0,1,0,.028c-.028-.009-.063,0-.08-.031a.1.1,0,0,1,0-.029Z",
  transform: "translate(-1418.984 -2370.415)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_637",
  "data-name": "Path 637",
  d: "M1852.22,1694.027c0,.022-.017.026-.028.033a.025.025,0,0,1-.021-.01c0-.02.016-.024.028-.032S1852.211,1694.024,1852.22,1694.027Z",
  transform: "translate(-1818.924 -1663.045)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_638",
  "data-name": "Path 638",
  d: "M2041.666,1960.693l0,.024c-.005,0-.013,0-.015,0a.081.081,0,0,1,0-.023Z",
  transform: "translate(-2004.384 -1924.059)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_639",
  "data-name": "Path 639",
  d: "M2058.684,1811.99l0,.016a.074.074,0,0,1-.02-.012s0-.009,0-.014Z",
  transform: "translate(-2021.032 -1778.504)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_640",
  "data-name": "Path 640",
  d: "M1758.1,1839l-.023,0s0-.013,0-.014a.1.1,0,0,1,.023,0Z",
  transform: "translate(-1726.829 -1804.931)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_641",
  "data-name": "Path 641",
  d: "M1638.9,1845.19l0,.016a.092.092,0,0,1-.02-.012.049.049,0,0,1,0-.014Z",
  transform: "translate(-1610.158 -1810.999)",
  fill: "#13484f"
}))));
export default __webpack_public_path__ + "static/media/MoverIllustration.84f7a140.svg";
export { SvgComponent as ReactComponent };